import { Rect } from "../../../types/layout/Rect";

export enum AfricaCountriesEnum {
    Morocco,
    Algeria,
    Tunisia,
    Libya,
    Egypt,
    WesternSahara,
    Mauritania,
    Mali,
    Niger,
    Chad,
    Sudan,
    Eritrea,
    Senegal,
    Gambia,
    GuineaBissau,
    Guinea,
    SierraLeone,
    Liberia,
    CoteDIvoire,
    BurkinaFaso,
    Ghana,
    Togo,
    Benin,
    Nigeria,
    Cameroon,
    CentAfrRep,
    SouthSudan,
    Ethiopia,
    Djibouti,
    Somalia,
    EqGuinea,
    Gabon,
    RepOfCongo,
    DemocraticRepOfCongo,
    Uganda,
    Rwanda,
    Burundi,
    Kenya,
    Tanzania,
    Angola,
    Zambia,
    Malawi,
    Mozambique,
    Namibia,
    Botswana,
    Zimbabwe,
    SouthAfrica,
    Lesotho,
    Eswatini,
}

export const AfricaCountriesBounds: Record<AfricaCountriesEnum, google.maps.LatLngLiteral[][]> = {
    [AfricaCountriesEnum.Tanzania]: [
        [
            { lng: 33.90371119710453, lat: -0.9500000000000001 },
            { lng: 31.866170000000068, lat: -1.0273599999999306 },
            { lng: 30.769860000000108, lat: -1.0145499999999856 },
            { lng: 30.419104852019245, lat: -1.1346591121504161 },
            { lng: 30.816134881317712, lat: -1.6989140763453887 },
            { lng: 30.75830895358311, lat: -2.2872502579883687 },
            { lng: 30.469670000000008, lat: -2.4138299999999617 },
            { lng: 30.469673645761223, lat: -2.41385475710134 },
            { lng: 30.527660000000026, lat: -2.807619999999986 },
            { lng: 30.743010000000027, lat: -3.034309999999948 },
            { lng: 30.752240000000086, lat: -3.3593099999999936 },
            { lng: 30.505539999999996, lat: -3.5685799999999404 },
            { lng: 30.11632000000003, lat: -4.090120000000013 },
            { lng: 29.753512404099865, lat: -4.452389418153302 },
            { lng: 29.339997592900346, lat: -4.4999834122940925 },
            { lng: 29.519986606572928, lat: -5.419978936386315 },
            { lng: 29.419992710088167, lat: -5.939998874539434 },
            { lng: 29.620032179490014, lat: -6.520015150583426 },
            { lng: 30.199996779101696, lat: -7.079980970898163 },
            { lng: 30.74001549655179, lat: -8.340007419470915 },
            { lng: 30.740009731422095, lat: -8.34000593035372 },
            { lng: 31.15775133695005, lat: -8.594578747317366 },
            { lng: 31.556348097466497, lat: -8.762048841998642 },
            { lng: 32.19186486179194, lat: -8.930358981973257 },
            { lng: 32.75937544122132, lat: -9.23059905358906 },
            { lng: 33.73972000000009, lat: -9.417149999999992 },
            { lng: 33.940837724096525, lat: -9.693673841980285 },
            { lng: 34.27999999999997, lat: -10.160000000000025 },
            { lng: 34.55998904799935, lat: -11.520020033415925 },
            { lng: 35.31239790216904, lat: -11.439146416879147 },
            { lng: 36.51408165868426, lat: -11.720938002166735 },
            { lng: 36.775150994622805, lat: -11.594537448780805 },
            { lng: 37.471289999999954, lat: -11.568759999999997 },
            { lng: 37.827639999999974, lat: -11.26878999999991 },
            { lng: 38.42755659358775, lat: -11.285202325081656 },
            { lng: 39.52099999999996, lat: -10.89688000000001 },
            { lng: 40.31659000000002, lat: -10.317099999999868 },
            { lng: 40.316586229110854, lat: -10.317097752817492 },
            { lng: 39.94960000000003, lat: -10.098400000000026 },
            { lng: 39.53574000000009, lat: -9.112369999999885 },
            { lng: 39.18652000000009, lat: -8.48550999999992 },
            { lng: 39.25203000000005, lat: -8.00780999999995 },
            { lng: 39.19468999999998, lat: -7.703899999999976 },
            { lng: 39.47000000000014, lat: -7.099999999999966 },
            { lng: 39.44, lat: -6.839999999999861 },
            { lng: 38.79977000000008, lat: -6.475660000000005 },
            { lng: 38.74053999999995, lat: -5.9089499999999475 },
            { lng: 39.20222, lat: -4.67677 },
            { lng: 37.7669, lat: -3.6771200000000004 },
            { lng: 37.69868999999994, lat: -3.0969899999999484 },
            { lng: 34.07261999999997, lat: -1.0598199999999451 },
            { lng: 33.90371119710453, lat: -0.9500000000000001 },
        ],
    ],
    [AfricaCountriesEnum.WesternSahara]: [
        [
            { lng: -13.121613369914769, lat: 27.65414767171984 },
            { lng: -13.13994177901435, lat: 27.640147813420526 },
            { lng: -13.773804897506466, lat: 26.618892320252314 },
            { lng: -14.439939947964831, lat: 26.254418443297652 },
            { lng: -14.800925665739726, lat: 25.63626496022232 },
            { lng: -14.824645148161665, lat: 25.103532619725343 },
            { lng: -15.089331834360735, lat: 24.520260728447 },
            { lng: -15.426003790742186, lat: 24.35913361256104 },
            { lng: -15.982610642958036, lat: 23.723358466074046 },
            { lng: -16.3264139469959, lat: 23.017768459560898 },
            { lng: -16.261921759495635, lat: 22.679339504481277 },
            { lng: -16.589136928767687, lat: 22.158234361250095 },
            { lng: -16.973247849993243, lat: 21.885744533774982 },
            { lng: -17.02042843267577, lat: 21.422310288981578 },
            { lng: -17.00296179856109, lat: 21.420734157796577 },
            { lng: -17.06342322434257, lat: 20.999752102130827 },
            { lng: -16.845193650773993, lat: 21.33332347257488 },
            { lng: -12.929101935263532, lat: 21.327070624267563 },
            { lng: -13.118754441774712, lat: 22.771220201096256 },
            { lng: -12.874221564169575, lat: 23.284832261645178 },
            { lng: -11.937224493853321, lat: 23.374594224536168 },
            { lng: -11.96941891117116, lat: 25.933352769468268 },
            { lng: -8.6872936670174, lat: 25.881056219988906 },
            { lng: -8.684399786809053, lat: 27.395744126896005 },
            { lng: -8.665124477564191, lat: 27.589479071558227 },
            { lng: -8.665589565454809, lat: 27.656425889592356 },
            { lng: -8.817828334986672, lat: 27.656425889592356 },
        ],
    ],
    [AfricaCountriesEnum.DemocraticRepOfCongo]: [
        [
            { lng: 29.339997592900346, lat: -4.4999834122940925 },
            { lng: 29.276383904749053, lat: -3.293907159034063 },
            { lng: 29.024926385216787, lat: -2.8392579077301576 },
            { lng: 29.117478875451553, lat: -2.2922111954883846 },
            { lng: 29.254834832483343, lat: -2.2151099585089113 },
            { lng: 29.291886834436614, lat: -1.6200558406679872 },
            { lng: 29.579466180140884, lat: -1.3413131648856265 },
            { lng: 29.58783776217217, lat: -0.587405694179381 },
            { lng: 29.819503208136638, lat: -0.2053101538133717 },
            { lng: 29.875778842902434, lat: 0.5973798689763612 },
            { lng: 30.086153598762706, lat: 1.0623127303062887 },
            { lng: 30.46850752129029, lat: 1.5838054467797065 },
            { lng: 30.85267011894806, lat: 1.8493964705438088 },
            { lng: 31.174149204235817, lat: 2.204465236821264 },
            { lng: 30.77334679538004, lat: 2.339883327642127 },
            { lng: 30.83385989759381, lat: 3.509165961110341 },
            { lng: 30.833852421715427, lat: 3.5091716042224625 },
            { lng: 29.953500197069474, lat: 4.173699042167684 },
            { lng: 29.71599531425602, lat: 4.600804755060153 },
            { lng: 29.1590784034465, lat: 4.389267279473231 },
            { lng: 28.696677687298802, lat: 4.455077215996937 },
            { lng: 28.428993768026913, lat: 4.287154649264494 },
            { lng: 27.97997724784281, lat: 4.408413397637375 },
            { lng: 27.37422610851749, lat: 5.233944403500061 },
            { lng: 27.04406538260471, lat: 5.127852688004836 },
            { lng: 26.402760857862543, lat: 5.1508745385908705 },
            { lng: 25.650455356557472, lat: 5.256087754737123 },
            { lng: 25.278798455514305, lat: 5.170408229997192 },
            { lng: 25.12883344900328, lat: 4.92724477784779 },
            { lng: 24.805028924262416, lat: 4.89724660890235 },
            { lng: 24.410531040146253, lat: 5.10878408448913 },
            { lng: 23.29721398285014, lat: 4.609693101414223 },
            { lng: 22.841479526468106, lat: 4.710126247573484 },
            { lng: 22.70412356943629, lat: 4.633050848810157 },
            { lng: 22.405123732195538, lat: 4.029160061047321 },
            { lng: 21.659122755630023, lat: 4.22434194581372 },
            { lng: 20.927591180106276, lat: 4.322785549329737 },
            { lng: 20.290679152108936, lat: 4.691677761245288 },
            { lng: 19.46778364429315, lat: 5.03152781821278 },
            { lng: 18.93231245288476, lat: 4.709506130385975 },
            { lng: 18.54298221199778, lat: 4.201785183118318 },
            { lng: 18.45306521980993, lat: 3.5043858911233485 },
            { lng: 18.393792351971143, lat: 2.90044342692822 },
            { lng: 18.094275750407434, lat: 2.365721543788055 },
            { lng: 17.898835483479587, lat: 1.7418319767282782 },
            { lng: 17.774191928791566, lat: 0.8556586775710854 },
            { lng: 17.826540154703252, lat: 0.28892324462610475 },
            { lng: 17.66355268725468, lat: -0.05808399821381727 },
            { lng: 17.638644646889986, lat: -0.4248316381892465 },
            { lng: 17.523716261472856, lat: -0.743830254726987 },
            { lng: 16.865306837642123, lat: -1.2258163387132868 },
            { lng: 16.407091912510054, lat: -1.7409270157986825 },
            { lng: 15.972803175529151, lat: -2.7123922664536124 },
            { lng: 16.0062895036543, lat: -3.535132744972529 },
            { lng: 15.753540073314753, lat: -3.8551648901560966 },
            { lng: 15.170991652088444, lat: -4.343507175314301 },
            { lng: 14.582603794013181, lat: -4.97023894615014 },
            { lng: 14.209034864975223, lat: -4.793092136253598 },
            { lng: 14.144956088933299, lat: -4.510008640158716 },
            { lng: 13.600234816144678, lat: -4.50013844159097 },
            { lng: 13.258240187237048, lat: -4.882957452009165 },
            { lng: 12.995517205465177, lat: -4.781103203961884 },
            { lng: 12.63161176926579, lat: -4.991271254092936 },
            { lng: 12.468004184629736, lat: -5.248361504745005 },
            { lng: 12.436688266660868, lat: -5.6843038875592455 },
            { lng: 12.182336866920252, lat: -5.789930515163839 },
            { lng: 12.32243167486351, lat: -6.10009246177966 },
            { lng: 12.735171339578699, lat: -5.965682061388499 },
            { lng: 13.024869419006961, lat: -5.984388929878158 },
            { lng: 13.375597364971895, lat: -5.8642412247995495 },
            { lng: 16.326528354567046, lat: -5.877470391466268 },
            { lng: 16.573179965896145, lat: -6.6226445451150875 },
            { lng: 16.8601908708452, lat: -7.2222978654299865 },
            { lng: 17.08999596524717, lat: -7.545688978712526 },
            { lng: 17.472970004962235, lat: -8.0685511206417 },
            { lng: 18.13422163256905, lat: -7.987677504104923 },
            { lng: 18.464175652752687, lat: -7.847014255406443 },
            { lng: 19.01675174324967, lat: -7.988245944860132 },
            { lng: 19.16661339689611, lat: -7.738183688999754 },
            { lng: 19.41750247567316, lat: -7.155428562044299 },
            { lng: 20.037723016040218, lat: -7.116361179231646 },
            { lng: 20.091621534920648, lat: -6.943090101756994 },
            { lng: 20.6018229509383, lat: -6.939317722199682 },
            { lng: 20.5147481625265, lat: -7.2996058081386295 },
            { lng: 21.7281107927397, lat: -7.290872491081302 },
            { lng: 21.74645592620331, lat: -7.920084730667149 },
            { lng: 21.949130893652043, lat: -8.305900974158277 },
            { lng: 21.8018013851879, lat: -8.90870655684298 },
            { lng: 21.875181919042348, lat: -9.523707777548566 },
            { lng: 22.208753289486395, lat: -9.894796237836509 },
            { lng: 22.155268182064308, lat: -11.084801120653772 },
            { lng: 22.402798292742375, lat: -10.993075453335692 },
            { lng: 22.83734541188474, lat: -11.01762175867433 },
            { lng: 23.45679080576744, lat: -10.867863457892483 },
            { lng: 23.912215203555718, lat: -10.926826267137514 },
            { lng: 24.25715538910399, lat: -10.951992689663657 },
            { lng: 24.31451622894795, lat: -11.26282642989927 },
            { lng: 24.78316979340295, lat: -11.238693536018964 },
            { lng: 25.418118116973204, lat: -11.330935967659961 },
            { lng: 25.752309604604733, lat: -11.784965101776358 },
            { lng: 26.553087599399618, lat: -11.924439792532127 },
            { lng: 27.164419793412463, lat: -11.608748467661075 },
            { lng: 27.388798862423783, lat: -12.132747491100666 },
            { lng: 28.155108676879987, lat: -12.272480564017897 },
            { lng: 28.523561639121027, lat: -12.698604424696683 },
            { lng: 28.934285922976837, lat: -13.248958428605135 },
            { lng: 29.69961388521949, lat: -13.257226657771831 },
            { lng: 29.61600141777123, lat: -12.178894545137311 },
            { lng: 29.34154788586909, lat: -12.360743910372413 },
            { lng: 28.642417433392353, lat: -11.971568698782315 },
            { lng: 28.372253045370428, lat: -11.793646742401393 },
            { lng: 28.49606977714177, lat: -10.789883721564046 },
            { lng: 28.67368167492893, lat: -9.605924981324932 },
            { lng: 28.449871046672826, lat: -9.164918308146085 },
            { lng: 28.734866570762502, lat: -8.526559340044578 },
            { lng: 29.00291222506047, lat: -8.407031752153472 },
            { lng: 30.346086053190817, lat: -8.238256524288218 },
            { lng: 30.740009731422095, lat: -8.34000593035372 },
            { lng: 30.74001549655179, lat: -8.340007419470915 },
            { lng: 30.199996779101696, lat: -7.079980970898163 },
            { lng: 29.620032179490014, lat: -6.520015150583426 },
            { lng: 29.419992710088167, lat: -5.939998874539434 },
            { lng: 29.519986606572928, lat: -5.419978936386315 },
            { lng: 29.339997592900346, lat: -4.4999834122940925 },
        ],
    ],
    [AfricaCountriesEnum.Somalia]: [
        [
            { lng: 44.96360000000001, lat: 5.00162 },
            { lng: 43.66086999999999, lat: 4.957550000000083 },
            { lng: 42.76967, lat: 4.25259 },
            { lng: 42.128609999999995, lat: 4.23413 },
            { lng: 41.85508309264397, lat: 3.918911920483727 },
            { lng: 40.98105, lat: 2.7845199999999997 },
            { lng: 40.993, lat: -0.85829 },
            { lng: 41.58513, lat: -1.6832500000000001 },
            { lng: 41.81095, lat: -1.4464700000000001 },
            { lng: 42.04157000000001, lat: -0.9191600000000001 },
            { lng: 43.13597, lat: 0.2922 },
            { lng: 44.068149999999996, lat: 1.0528300000000002 },
            { lng: 45.563990000000004, lat: 2.04576 },
            { lng: 46.56476, lat: 2.85529 },
            { lng: 47.740790000000004, lat: 4.2194 },
            { lng: 48.594550000000005, lat: 5.339110000000001 },
            { lng: 49.45270000000001, lat: 6.80466 },
            { lng: 50.07092, lat: 8.08173 },
            { lng: 50.55239, lat: 9.19874 },
            { lng: 50.834179999999996, lat: 10.279720000000001 },
            { lng: 51.04531, lat: 10.6409 },
            { lng: 51.04153, lat: 11.16651 },
            { lng: 51.13387, lat: 11.74815 },
            { lng: 51.1112, lat: 12.024640000000002 },
            { lng: 50.73202, lat: 12.021900000000002 },
            { lng: 50.25878000000001, lat: 11.67957 },
            { lng: 49.72862, lat: 11.5789 },
            { lng: 49.26776, lat: 11.43033 },
            { lng: 48.94820475850985, lat: 11.41061728169797 },
            { lng: 48.94820641459347, lat: 11.41062164961852 },
            { lng: 48.37878380716927, lat: 11.375481675660126 },
            { lng: 48.02159630716778, lat: 11.193063869669743 },
            { lng: 47.525657586462785, lat: 11.12722809492999 },
            { lng: 46.645401238803004, lat: 10.816549383991173 },
            { lng: 45.55694054543915, lat: 10.698029486529776 },
            { lng: 44.614259067570856, lat: 10.442205308468942 },
            { lng: 44.11780358254282, lat: 10.445538438351605 },
            { lng: 43.66666832863484, lat: 10.86416921634816 },
            { lng: 43.470659620951665, lat: 11.277709865763882 },
            { lng: 43.14530480324214, lat: 11.462039699748857 },
            { lng: 42.77685184100096, lat: 10.92687856693442 },
            { lng: 42.55875999999995, lat: 10.57258000000013 },
            { lng: 42.92812000000009, lat: 10.021940000000143 },
            { lng: 43.29699000000011, lat: 9.540480000000173 },
            { lng: 43.678750000000036, lat: 9.18358000000012 },
            { lng: 46.94834000000009, lat: 7.99688000000009 },
            { lng: 47.78942, lat: 8.003 },
        ],
    ],
    [AfricaCountriesEnum.Kenya]: [
        [
            { lng: 39.20222, lat: -4.67677 },
            { lng: 39.604890000000005, lat: -4.3465300000000004 },
            { lng: 39.80006, lat: -3.68116 },
            { lng: 40.12119, lat: -3.27768 },
            { lng: 40.26304000000001, lat: -2.57309 },
            { lng: 40.63785000000001, lat: -2.49979 },
            { lng: 40.88477, lat: -2.08255 },
            { lng: 41.58513, lat: -1.6832500000000001 },
            { lng: 40.993, lat: -0.85829 },
            { lng: 40.98105, lat: 2.7845199999999997 },
            { lng: 41.85508309264397, lat: 3.918911920483727 },
            { lng: 41.1718, lat: 3.9190899999999997 },
            { lng: 40.76848, lat: 4.257020000000001 },
            { lng: 39.85494, lat: 3.83879 },
            { lng: 39.55938425876585, lat: 3.42206 },
            { lng: 38.89251, lat: 3.5007400000000004 },
            { lng: 38.67114, lat: 3.6160700000000006 },
            { lng: 38.43697, lat: 3.58851 },
            { lng: 38.120915, lat: 3.598605 },
            { lng: 36.85509323800812, lat: 4.447864127672769 },
            { lng: 36.159078632855646, lat: 4.447864127672769 },
            { lng: 35.817447662353516, lat: 4.7769656634618896 },
            { lng: 35.817447662353516, lat: 5.338232082790797 },
            { lng: 35.29800711823298, lat: 5.506 },
            { lng: 34.62019626785388, lat: 4.8471227420819885 },
            { lng: 34.005, lat: 4.249884947362048 },
            { lng: 34.47913, lat: 3.5556000000000836 },
            { lng: 34.59607, lat: 3.0537400000001185 },
            { lng: 35.03599, lat: 1.90584 },
            { lng: 34.6721, lat: 1.1769399999999999 },
            { lng: 34.18, lat: 0.515 },
            { lng: 33.893568969666944, lat: 0.1098135378618963 },
            { lng: 33.90371119710453, lat: -0.9500000000000001 },
            { lng: 34.07261999999997, lat: -1.0598199999999451 },
            { lng: 37.69868999999994, lat: -3.0969899999999484 },
            { lng: 37.7669, lat: -3.6771200000000004 },
            { lng: 39.20222, lat: -4.67677 },
        ],
    ],
    [AfricaCountriesEnum.Sudan]: [
        [
            { lng: 24.567369012152085, lat: 8.229187933785468 },
            { lng: 23.886979580860668, lat: 8.619729712933065 },
            { lng: 24.19406772118765, lat: 8.728696472403897 },
            { lng: 24.53741516360202, lat: 8.91753756573172 },
            { lng: 24.794925745412684, lat: 9.810240916008695 },
            { lng: 25.069603699343986, lat: 10.273759963267992 },
            { lng: 25.790633328413946, lat: 10.411098940233728 },
            { lng: 25.962307049621018, lat: 10.136420986302426 },
            { lng: 26.477328213242515, lat: 9.552730334198088 },
            { lng: 26.752006167173818, lat: 9.466893473594496 },
            { lng: 27.112520981708883, lat: 9.638567194801624 },
            { lng: 27.833550610778786, lat: 9.60423245056029 },
            { lng: 27.970889587744352, lat: 9.398223985111656 },
            { lng: 28.966597170745786, lat: 9.398223985111656 },
            { lng: 29.000931914987177, lat: 9.60423245056029 },
            { lng: 29.515953078608618, lat: 9.793073543888056 },
            { lng: 29.61895731133285, lat: 10.084918869940225 },
            { lng: 29.996639497988554, lat: 10.290927335388687 },
            { lng: 30.837840731903384, lat: 9.70723668328452 },
            { lng: 31.35286189552488, lat: 9.810240916008695 },
            { lng: 31.850715687025513, lat: 10.531270545078826 },
            { lng: 32.400071594888345, lat: 11.080626452941488 },
            { lng: 32.31423473428475, lat: 11.68148447716652 },
            { lng: 32.073891524594785, lat: 11.973329803218519 },
            { lng: 32.67474954881965, lat: 12.02483191958072 },
            { lng: 32.743419037302544, lat: 12.248007757149992 },
            { lng: 33.206938084561784, lat: 12.179338268667095 },
            { lng: 33.086766479716744, lat: 11.441141267476496 },
            { lng: 33.206938084561784, lat: 10.720111638406593 },
            { lng: 33.72195924818311, lat: 10.325262079630193 },
            { lng: 33.84213085302815, lat: 9.981914637215993 },
            { lng: 33.82496348090751, lat: 9.484060845715362 },
            { lng: 33.963392794971185, lat: 9.464285229420625 },
            { lng: 33.97498000000007, lat: 8.68455999999992 },
            { lng: 33.961620000000096, lat: 9.583580000000097 },
            { lng: 34.25745000000006, lat: 10.630089999999996 },
            { lng: 34.73115000000013, lat: 10.910170000000107 },
            { lng: 34.83163000000013, lat: 11.318960000000118 },
            { lng: 35.26049000000006, lat: 12.08286000000004 },
            { lng: 35.86363, lat: 12.578280000000063 },
            { lng: 36.27022000000005, lat: 13.563330000000121 },
            { lng: 36.42951000000005, lat: 14.422110000000032 },
            { lng: 36.32321999999999, lat: 14.822490000000016 },
            { lng: 36.75389000000007, lat: 16.291860000000042 },
            { lng: 36.852530000000115, lat: 16.956549999999993 },
            { lng: 37.167470000000094, lat: 17.263140000000135 },
            { lng: 37.90400000000011, lat: 17.427540000000022 },
            { lng: 38.410089959473225, lat: 17.998307399970315 },
            { lng: 37.862760000000094, lat: 18.36785999999995 },
            { lng: 37.4817900000001, lat: 18.61409000000009 },
            { lng: 37.11470000000014, lat: 19.807960000000094 },
            { lng: 36.969409999999925, lat: 20.83744000000013 },
            { lng: 37.1887200000001, lat: 21.018850000000043 },
            { lng: 36.86622999999997, lat: 22 },
            { lng: 32.89999999999998, lat: 22 },
            { lng: 29.019999999999982, lat: 22 },
            { lng: 25, lat: 22 },
            { lng: 25.000000000000114, lat: 20.003040000000055 },
            { lng: 23.850000000000136, lat: 20.000000000000057 },
            { lng: 23.83766000000014, lat: 19.580470000000105 },
            { lng: 23.886890000000108, lat: 15.610839999999996 },
            { lng: 23.024590000000103, lat: 15.680720000000065 },
            { lng: 22.56795000000011, lat: 14.944290000000137 },
            { lng: 22.30350999999996, lat: 14.326820000000055 },
            { lng: 22.512020000000007, lat: 14.093179999999961 },
            { lng: 22.18329, lat: 13.78648000000004 },
            { lng: 22.296580000000006, lat: 13.372319999999945 },
            { lng: 22.037589999999966, lat: 12.95545999999996 },
            { lng: 21.93680999999998, lat: 12.588180000000136 },
            { lng: 22.288010000000043, lat: 12.646049999999946 },
            { lng: 22.497619999999984, lat: 12.260240000000067 },
            { lng: 22.50869, lat: 11.679360000000031 },
            { lng: 22.876219999999932, lat: 11.384610000000123 },
            { lng: 22.864165480244225, lat: 11.142395127807546 },
            { lng: 22.97754357269261, lat: 10.71446259199854 },
            { lng: 23.554304233502194, lat: 10.089255275915308 },
            { lng: 23.55724979014283, lat: 9.681218166538684 },
            { lng: 23.394779087017184, lat: 9.265067857292223 },
            { lng: 23.459012892355986, lat: 8.954285793488893 },
            { lng: 23.805813429466752, lat: 8.666318874542526 },
            { lng: 24.567369012152085, lat: 8.229187933785468 },
        ],
    ],
    [AfricaCountriesEnum.Chad]: [
        [
            { lng: 23.83766000000014, lat: 19.580470000000105 },
            { lng: 19.849260000000072, lat: 21.49509000000006 },
            { lng: 15.860850000000084, lat: 23.409719999999993 },
            { lng: 14.851300000000037, lat: 22.862950000000126 },
            { lng: 15.096887648181848, lat: 21.30851878507491 },
            { lng: 15.47106000000008, lat: 21.04845000000006 },
            { lng: 15.487148064850146, lat: 20.730414537025638 },
            { lng: 15.903246697664315, lat: 20.387618923417506 },
            { lng: 15.685740594147774, lat: 19.957180080642388 },
            { lng: 15.30044111497972, lat: 17.927949937405003 },
            { lng: 15.247731154041844, lat: 16.627305813050782 },
            { lng: 13.972170000000006, lat: 15.684370000000058 },
            { lng: 13.540393507550789, lat: 14.367133693901224 },
            { lng: 13.633358769584465, lat: 13.725803760168045 },
            { lng: 14.083798222709465, lat: 13.084587242198625 },
            { lng: 14.468319707084465, lat: 13.095288098886034 },
            { lng: 14.89336000000003, lat: 12.219049999999982 },
            { lng: 14.9601518083376, lat: 11.555574042197224 },
            { lng: 14.92356489427496, lat: 10.891325181517473 },
            { lng: 15.467872755605242, lat: 9.982336737503545 },
            { lng: 14.909353875394716, lat: 9.992129421422732 },
            { lng: 14.62720055508106, lat: 9.920919297724538 },
            { lng: 14.171466098699028, lat: 10.021378282099931 },
            { lng: 13.954218377344006, lat: 9.549494940626687 },
            { lng: 14.54446658698177, lat: 8.965861314322268 },
            { lng: 14.97999555833769, lat: 8.796104234243472 },
            { lng: 15.120865512765306, lat: 8.382150173369439 },
            { lng: 15.436091749745742, lat: 7.692812404811889 },
            { lng: 15.279460483469109, lat: 7.421924546737969 },
            { lng: 16.106231723706742, lat: 7.497087917506462 },
            { lng: 16.290561557691888, lat: 7.754307359239419 },
            { lng: 16.456184523187346, lat: 7.734773667832968 },
            { lng: 16.705988396886255, lat: 7.5083275415299795 },
            { lng: 17.964929640380888, lat: 7.890914008002994 },
            { lng: 18.38955488452322, lat: 8.281303615751824 },
            { lng: 18.911021762780507, lat: 8.630894680206353 },
            { lng: 18.812009718509273, lat: 8.982914536978598 },
            { lng: 19.09400800952602, lat: 9.07484691002584 },
            { lng: 20.05968549976427, lat: 9.012706000194854 },
            { lng: 21.000868361096167, lat: 9.475985215691509 },
            { lng: 21.723821648859456, lat: 10.567055568885976 },
            { lng: 22.23112918466876, lat: 10.97188873946061 },
            { lng: 22.864165480244225, lat: 11.142395127807546 },
            { lng: 22.876219999999932, lat: 11.384610000000123 },
            { lng: 22.50869, lat: 11.679360000000031 },
            { lng: 22.497619999999984, lat: 12.260240000000067 },
            { lng: 22.288010000000043, lat: 12.646049999999946 },
            { lng: 21.93680999999998, lat: 12.588180000000136 },
            { lng: 22.037589999999966, lat: 12.95545999999996 },
            { lng: 22.296580000000006, lat: 13.372319999999945 },
            { lng: 22.18329, lat: 13.78648000000004 },
            { lng: 22.512020000000007, lat: 14.093179999999961 },
            { lng: 22.30350999999996, lat: 14.326820000000055 },
            { lng: 22.56795000000011, lat: 14.944290000000137 },
            { lng: 23.024590000000103, lat: 15.680720000000065 },
            { lng: 23.886890000000108, lat: 15.610839999999996 },
            { lng: 23.83766000000014, lat: 19.580470000000105 },
        ],
    ],
    [AfricaCountriesEnum.SouthAfrica]: [
        [
            { lng: 16.344976840895242, lat: -28.5767050106977 },
            { lng: 17.062917514726223, lat: -29.875953871379984 },
            { lng: 17.064416131262703, lat: -29.878641045859162 },
            { lng: 17.56691775886887, lat: -30.725721123987547 },
            { lng: 18.22176150887148, lat: -31.66163298922567 },
            { lng: 18.247909783611192, lat: -32.42913136162457 },
            { lng: 17.92519046394844, lat: -32.61129078545343 },
            { lng: 18.250080193767445, lat: -33.28143075941444 },
            { lng: 18.24449913907992, lat: -33.86775156019803 },
            { lng: 18.377410922934615, lat: -34.13652068454807 },
            { lng: 18.42464318204938, lat: -33.99787281670897 },
            { lng: 18.85531456876987, lat: -34.444305515278465 },
            { lng: 19.193278435958717, lat: -34.46259897230979 },
            { lng: 19.61640506356457, lat: -34.81916635512371 },
            { lng: 20.071261020597632, lat: -34.79513681410799 },
            { lng: 20.689052768647002, lat: -34.417175388325234 },
            { lng: 21.542799106541025, lat: -34.258838799782936 },
            { lng: 22.574157342222236, lat: -33.86408253350531 },
            { lng: 22.988188917744736, lat: -33.91643075941698 },
            { lng: 23.594043409934642, lat: -33.794474379208154 },
            { lng: 24.677853224392123, lat: -33.98717579522455 },
            { lng: 25.172861769315972, lat: -33.796851495093584 },
            { lng: 25.780628289500697, lat: -33.94464609144834 },
            { lng: 25.90966434093349, lat: -33.6670402971764 },
            { lng: 26.419452345492825, lat: -33.61495045342619 },
            { lng: 27.464608188595975, lat: -33.2269637997788 },
            { lng: 28.2197558936771, lat: -32.771952813448856 },
            { lng: 28.92555260591954, lat: -32.1720411109725 },
            { lng: 30.05571618014278, lat: -31.140269463832958 },
            { lng: 30.62281334811382, lat: -30.42377573010613 },
            { lng: 30.901762729625347, lat: -29.909956963828037 },
            { lng: 31.325561150851, lat: -29.401977634398914 },
            { lng: 31.521001417778876, lat: -29.257386976846256 },
            { lng: 32.20338870619304, lat: -28.75240488049007 },
            { lng: 32.46213260267845, lat: -28.301011244420557 },
            { lng: 32.580264926897684, lat: -27.470157566031816 },
            { lng: 32.830120477028885, lat: -26.742191664336197 },
            { lng: 32.07166548028107, lat: -26.73382008230491 },
            { lng: 31.86806033705108, lat: -27.177927341421277 },
            { lng: 31.28277306491333, lat: -27.285879408478998 },
            { lng: 30.68596194837448, lat: -26.743845310169533 },
            { lng: 30.67660851412964, lat: -26.398078301704608 },
            { lng: 30.949666782359913, lat: -26.02264902110415 },
            { lng: 31.04407962415715, lat: -25.731452325139443 },
            { lng: 31.333157586397903, lat: -25.66019052500895 },
            { lng: 31.83777794772806, lat: -25.84333180105135 },
            { lng: 31.75240848158188, lat: -25.484283949487413 },
            { lng: 31.930588820124253, lat: -24.36941659922254 },
            { lng: 31.670397983534656, lat: -23.658969008073864 },
            { lng: 31.19140913262129, lat: -22.2515096981724 },
            { lng: 30.65986535006709, lat: -22.151567478119915 },
            { lng: 30.322883335091774, lat: -22.271611830333935 },
            { lng: 29.839036899542972, lat: -22.102216485281176 },
            { lng: 29.43218834810904, lat: -22.091312758067588 },
            { lng: 28.01723595552525, lat: -22.82775359465908 },
            { lng: 27.119409620886245, lat: -23.574323011979775 },
            { lng: 26.786406691197413, lat: -24.240690606383485 },
            { lng: 26.4857532081233, lat: -24.616326592713104 },
            { lng: 25.94165205252216, lat: -24.69637338633322 },
            { lng: 25.76584882986521, lat: -25.17484547292368 },
            { lng: 25.66466637543772, lat: -25.486816094669713 },
            { lng: 25.025170525825786, lat: -25.7196700985769 },
            { lng: 24.211266717228796, lat: -25.670215752873574 },
            { lng: 23.73356977712271, lat: -25.390129489851617 },
            { lng: 23.312096795350186, lat: -25.26868987396572 },
            { lng: 22.8242712745149, lat: -25.50045867279477 },
            { lng: 22.57953169118059, lat: -25.979447523708146 },
            { lng: 22.105968865657868, lat: -26.280256036079138 },
            { lng: 21.605896030369394, lat: -26.726533705351756 },
            { lng: 20.88960900237174, lat: -26.828542982695915 },
            { lng: 20.66647016773544, lat: -26.477453301704923 },
            { lng: 20.75860924651184, lat: -25.86813648855145 },
            { lng: 20.16572553882719, lat: -24.91796192800077 },
            { lng: 19.895767856534434, lat: -24.76779021576059 },
            { lng: 19.894734327888614, lat: -28.461104831660776 },
            { lng: 19.002127312911085, lat: -28.972443129188868 },
            { lng: 18.464899122804752, lat: -29.04546192801728 },
            { lng: 17.83615197110953, lat: -28.85637786226132 },
            { lng: 17.387497185951503, lat: -28.78351409272978 },
            { lng: 17.218928663815404, lat: -28.35594329194681 },
            { lng: 16.824017368240902, lat: -28.08216155366447 },
            { lng: 16.344976840895242, lat: -28.5767050106977 },
        ],
    ],
    [AfricaCountriesEnum.Lesotho]: [
        [
            { lng: 28.978262566857243, lat: -28.95559661226171 },
            { lng: 28.541700066855498, lat: -28.64750172293757 },
            { lng: 28.074338413207784, lat: -28.851468601193588 },
            { lng: 27.532511020627478, lat: -29.24271087007536 },
            { lng: 26.999261915807637, lat: -29.875953871379984 },
            { lng: 27.749397006956485, lat: -30.645105889612225 },
            { lng: 28.107204624145425, lat: -30.54573211031495 },
            { lng: 28.29106937023991, lat: -30.2262167294543 },
            { lng: 28.84839969250774, lat: -30.070050551068256 },
            { lng: 29.018415154748027, lat: -29.74376555757737 },
            { lng: 29.32516645683259, lat: -29.257386976846256 },
            { lng: 28.978262566857243, lat: -28.95559661226171 },
        ],
    ],
    [AfricaCountriesEnum.Zimbabwe]: [
        [
            { lng: 31.19140913262129, lat: -22.2515096981724 },
            { lng: 32.244988234188014, lat: -21.116488539313693 },
            { lng: 32.50869306817344, lat: -20.395292250248307 },
            { lng: 32.65974327976258, lat: -20.304290052982317 },
            { lng: 32.772707960752626, lat: -19.715592136313298 },
            { lng: 32.61199425632489, lat: -19.419382826416275 },
            { lng: 32.65488569512715, lat: -18.672089939043495 },
            { lng: 32.84986087416439, lat: -17.97905730557718 },
            { lng: 32.847638787575846, lat: -16.713398125884616 },
            { lng: 32.32823896661023, lat: -16.392074069893752 },
            { lng: 31.8520406430406, lat: -16.319417006091378 },
            { lng: 31.636498243951195, lat: -16.071990248277885 },
            { lng: 31.17306399915768, lat: -15.860943698797874 },
            { lng: 30.338954705534544, lat: -15.880839125230246 },
            { lng: 30.27425581230511, lat: -15.507786960515213 },
            { lng: 29.516834344203147, lat: -15.644677829656388 },
            { lng: 28.947463413211267, lat: -16.04305144619444 },
            { lng: 28.8258687680285, lat: -16.389748630440614 },
            { lng: 28.467906121542683, lat: -16.468400160388846 },
            { lng: 27.59824344250276, lat: -17.290830580314008 },
            { lng: 27.044427117630732, lat: -17.938026218337434 },
            { lng: 26.70677330903564, lat: -17.961228936436484 },
            { lng: 26.381935255648926, lat: -17.8460421688579 },
            { lng: 25.262336480636822, lat: -17.790922257594097 },
            { lng: 25.649163445750162, lat: -18.53602589281899 },
            { lng: 25.85039147309473, lat: -18.714412937090536 },
            { lng: 26.164790887158485, lat: -19.29308562589494 },
            { lng: 27.296504754350508, lat: -20.391519870691 },
            { lng: 27.724747348753255, lat: -20.49905852629039 },
            { lng: 27.72722781750326, lat: -20.851801853114715 },
            { lng: 28.021370070108617, lat: -21.485975030200585 },
            { lng: 28.794656202924216, lat: -21.63945403410745 },
            { lng: 29.43218834810904, lat: -22.091312758067588 },
            { lng: 29.839036899542972, lat: -22.102216485281176 },
            { lng: 30.322883335091774, lat: -22.271611830333935 },
            { lng: 30.65986535006709, lat: -22.151567478119915 },
            { lng: 31.19140913262129, lat: -22.2515096981724 },
        ],
    ],
    [AfricaCountriesEnum.Botswana]: [
        [
            { lng: 29.43218834810904, lat: -22.091312758067588 },
            { lng: 28.794656202924216, lat: -21.63945403410745 },
            { lng: 28.021370070108617, lat: -21.485975030200585 },
            { lng: 27.72722781750326, lat: -20.851801853114715 },
            { lng: 27.724747348753255, lat: -20.49905852629039 },
            { lng: 27.296504754350508, lat: -20.391519870691 },
            { lng: 26.164790887158485, lat: -19.29308562589494 },
            { lng: 25.85039147309473, lat: -18.714412937090536 },
            { lng: 25.649163445750162, lat: -18.53602589281899 },
            { lng: 25.262336480636822, lat: -17.790922257594097 },
            { lat: -17.766702551579186, lng: 25.170394897460955 },
            { lng: 24.520705193792537, lat: -17.887124932529936 },
            { lng: 24.217364536239213, lat: -17.88934701911849 },
            { lng: 23.579005568137717, lat: -18.28126108162006 },
            { lng: 23.1968583513393, lat: -17.869038181227786 },
            { lng: 21.655040317478978, lat: -18.219146010005225 },
            { lng: 20.910641310314535, lat: -18.252218926672022 },
            { lng: 20.88113406747587, lat: -21.814327080983148 },
            { lng: 19.89545779794068, lat: -21.84915699634787 },
            { lng: 19.895767856534434, lat: -24.76779021576059 },
            { lng: 20.16572553882719, lat: -24.91796192800077 },
            { lng: 20.75860924651184, lat: -25.86813648855145 },
            { lng: 20.66647016773544, lat: -26.477453301704923 },
            { lng: 20.88960900237174, lat: -26.828542982695915 },
            { lng: 21.605896030369394, lat: -26.726533705351756 },
            { lng: 22.105968865657868, lat: -26.280256036079138 },
            { lng: 22.57953169118059, lat: -25.979447523708146 },
            { lng: 22.8242712745149, lat: -25.50045867279477 },
            { lng: 23.312096795350186, lat: -25.26868987396572 },
            { lng: 23.73356977712271, lat: -25.390129489851617 },
            { lng: 24.211266717228796, lat: -25.670215752873574 },
            { lng: 25.025170525825786, lat: -25.7196700985769 },
            { lng: 25.66466637543772, lat: -25.486816094669713 },
            { lng: 25.76584882986521, lat: -25.17484547292368 },
            { lng: 25.94165205252216, lat: -24.69637338633322 },
            { lng: 26.4857532081233, lat: -24.616326592713104 },
            { lng: 26.786406691197413, lat: -24.240690606383485 },
            { lng: 27.119409620886245, lat: -23.574323011979775 },
            { lng: 28.01723595552525, lat: -22.82775359465908 },
            { lng: 29.43218834810904, lat: -22.091312758067588 },
        ],
    ],
    [AfricaCountriesEnum.Namibia]: [
        [
            { lng: 19.895767856534434, lat: -24.76779021576059 },
            { lng: 19.89545779794068, lat: -21.84915699634787 },
            { lng: 20.88113406747587, lat: -21.814327080983148 },
            { lng: 20.910641310314535, lat: -18.252218926672022 },
            { lng: 21.655040317478978, lat: -18.219146010005225 },
            { lng: 23.1968583513393, lat: -17.869038181227786 },
            { lng: 23.579005568137717, lat: -18.28126108162006 },
            { lng: 24.217364536239213, lat: -17.88934701911849 },
            { lng: 24.520705193792537, lat: -17.887124932529936 },
            { lat: -17.766702551579186, lng: 25.170394897460955 },
            { lng: 25.07695031098226, lat: -17.57882333747662 },
            { lng: 24.682349074001507, lat: -17.353410739819473 },
            { lng: 24.033861525170778, lat: -17.295843194246324 },
            { lng: 23.215048455506064, lat: -17.523116143465984 },
            { lng: 21.377176141045567, lat: -17.930636488519696 },
            { lng: 18.956186964603603, lat: -17.789094740472258 },
            { lng: 18.263309360434164, lat: -17.309950860262006 },
            { lng: 14.209706658595024, lat: -17.35310068122572 },
            { lng: 14.05850141770901, lat: -17.423380629142663 },
            { lng: 13.462362094789967, lat: -16.971211846588773 },
            { lng: 12.814081251688407, lat: -16.94134286872407 },
            { lng: 12.215461460019355, lat: -17.111668389558083 },
            { lng: 11.734198846085121, lat: -17.301889336824473 },
            { lng: 11.794918654028066, lat: -18.069129327061916 },
            { lng: 12.608564080463621, lat: -19.0453488094877 },
            { lng: 12.826845330464494, lat: -19.673165785401665 },
            { lng: 13.35249799973744, lat: -20.872834161057504 },
            { lng: 13.86864220546866, lat: -21.699036960539978 },
            { lng: 14.257714064194175, lat: -22.111208184499958 },
            { lng: 14.385716586981149, lat: -22.65665292734069 },
            { lng: 14.408144158595833, lat: -23.853014011329847 },
            { lng: 14.743214145576331, lat: -25.39292001719538 },
            { lng: 14.989710727608553, lat: -26.117371921495156 },
            { lng: 15.21047244635946, lat: -27.090955905874047 },
            { lng: 15.601818068105816, lat: -27.821247247022804 },
            { lng: 16.344976840895242, lat: -28.5767050106977 },
            { lng: 16.824017368240902, lat: -28.08216155366447 },
            { lng: 17.218928663815404, lat: -28.35594329194681 },
            { lng: 17.387497185951503, lat: -28.78351409272978 },
            { lng: 17.83615197110953, lat: -28.85637786226132 },
            { lng: 18.464899122804752, lat: -29.04546192801728 },
            { lng: 19.002127312911085, lat: -28.972443129188868 },
            { lng: 19.894734327888614, lat: -28.461104831660776 },
            { lng: 19.895767856534434, lat: -24.76779021576059 },
        ],
    ],
    [AfricaCountriesEnum.Senegal]: [
        [
            { lng: -16.71372880702347, lat: 13.594958604379855 },
            { lng: -15.624596320039942, lat: 13.62358734786956 },
            { lng: -15.39877031092446, lat: 13.86036876063092 },
            { lng: -15.08173539881382, lat: 13.876491807505985 },
            { lng: -14.687030808968487, lat: 13.630356960499784 },
            { lng: -14.376713833055788, lat: 13.625680243377374 },
            { lng: -14.046992356817482, lat: 13.79406789800045 },
            { lng: -13.844963344772408, lat: 13.505041612192002 },
            { lng: -14.277701788784555, lat: 13.280585028532244 },
            { lng: -14.712197231494628, lat: 13.298206691943777 },
            { lng: -15.141163295949468, lat: 13.509511623585238 },
            { lng: -15.511812506562933, lat: 13.278569647672867 },
            { lng: -15.691000535534995, lat: 13.270353094938457 },
            { lng: -15.931295945692211, lat: 13.130284125211332 },
            { lng: -16.841524624081273, lat: 13.15139394780256 },
            { lng: -16.677451951554573, lat: 12.384851589401052 },
            { lng: -16.147716844130585, lat: 12.547761542201187 },
            { lng: -15.816574266004254, lat: 12.515567124883347 },
            { lng: -15.54847693527401, lat: 12.628170070847347 },
            { lng: -13.700476040084325, lat: 12.586182969610194 },
            { lng: -13.217818162478238, lat: 12.575873521367967 },
            { lng: -12.499050665730564, lat: 12.332089952031057 },
            { lng: -12.27859900557344, lat: 12.354440008997287 },
            { lng: -12.203564825885634, lat: 12.465647691289405 },
            { lng: -11.658300950557932, lat: 12.386582749882836 },
            { lng: -11.51394283695059, lat: 12.442987575729418 },
            { lng: -11.467899135778524, lat: 12.754518947800975 },
            { lng: -11.55339779300543, lat: 13.141213690641067 },
            { lng: -11.927716030311615, lat: 13.422075100147396 },
            { lng: -12.12488745772126, lat: 13.994727484589788 },
            { lng: -12.170750291380301, lat: 14.616834214735505 },
            { lng: -12.830658331747516, lat: 15.303691514542948 },
            { lng: -13.435737677453062, lat: 16.03938304286619 },
            { lng: -14.099521450242179, lat: 16.304302273010492 },
            { lng: -14.577347581428981, lat: 16.59826365810281 },
            { lng: -15.135737270558819, lat: 16.587282416240782 },
            { lng: -15.623666144258692, lat: 16.369337063049812 },
            { lng: -16.12069007004193, lat: 16.455662543193384 },
            { lng: -16.463098110407884, lat: 16.13503611903846 },
            { lng: -16.700706346085923, lat: 15.621527411354108 },
            { lng: -17.18517289882223, lat: 14.919477240452862 },
            { lng: -17.62504269049066, lat: 14.729540513564073 },
            { lng: -17.126106736712615, lat: 14.373515733289224 },
            { lng: -16.71372880702347, lat: 13.594958604379855 },
        ],
    ],
    [AfricaCountriesEnum.Mali]: [
        [
            { lng: -11.51394283695059, lat: 12.442987575729418 },
            { lng: -11.456168585648271, lat: 12.076834214725338 },
            { lng: -11.297573614944511, lat: 12.077971096235771 },
            { lng: -11.03655595543826, lat: 12.211244615116515 },
            { lng: -10.870829637078215, lat: 12.17788747807211 },
            { lng: -10.593223842806282, lat: 11.92397532800598 },
            { lng: -10.165213792348837, lat: 11.844083563682744 },
            { lng: -9.890992804392013, lat: 12.060478623904972 },
            { lng: -9.567911749703214, lat: 12.194243068892476 },
            { lng: -9.327616339546012, lat: 12.334286200403454 },
            { lng: -9.127473517279583, lat: 12.308060411015333 },
            { lng: -8.90526485842453, lat: 12.088358059126437 },
            { lng: -8.786099005559464, lat: 11.812560939984706 },
            { lng: -8.376304897484914, lat: 11.393645941610629 },
            { lng: -8.581305304386774, lat: 11.136245632364805 },
            { lng: -8.620321010767128, lat: 10.810890814655183 },
            { lng: -8.407310756860028, lat: 10.909256903522762 },
            { lng: -8.282357143578281, lat: 10.792597357623846 },
            { lng: -8.33537716310974, lat: 10.494811916541934 },
            { lng: -8.029943610048619, lat: 10.206534939001713 },
            { lng: -7.899589809592372, lat: 10.297382106970828 },
            { lng: -7.622759161804809, lat: 10.147236232946796 },
            { lng: -6.8505065576350574, lat: 10.138993841996239 },
            { lng: -6.666460944027548, lat: 10.430810655148449 },
            { lng: -6.493965013037268, lat: 10.411302801958271 },
            { lng: -6.205222947606431, lat: 10.524060777219134 },
            { lng: -6.050452032892267, lat: 10.096360785355444 },
            { lng: -5.816926235365287, lat: 10.222554633012194 },
            { lng: -5.404341599946974, lat: 10.370736802609146 },
            { lng: -5.470564947929006, lat: 10.951269842976048 },
            { lng: -5.1978425765086484, lat: 11.37514577885014 },
            { lng: -5.220941941743121, lat: 11.713858954307227 },
            { lng: -4.427166103523803, lat: 12.542645575404295 },
            { lng: -4.28040503581488, lat: 13.228443508349741 },
            { lng: -4.006390753587226, lat: 13.472485459848116 },
            { lng: -3.522802700199861, lat: 13.337661647998615 },
            { lng: -3.1037068343127596, lat: 13.541266791228594 },
            { lng: -2.9676944645205765, lat: 13.79815033615151 },
            { lng: -2.1918245100903846, lat: 14.246417548067356 },
            { lng: -2.001035122068771, lat: 14.559008287000893 },
            { lng: -1.0663634912056636, lat: 14.973815009007765 },
            { lng: -0.5158544580003479, lat: 15.116157741755728 },
            { lng: -0.2662572900305804, lat: 14.924308986872148 },
            { lng: 0.3748922054146817, lat: 14.92890818934613 },
            { lng: 1.0157833186984817, lat: 14.96818227788799 },
            { lng: 1.3855281917468576, lat: 15.323561102759172 },
            { lng: 2.749992709981484, lat: 15.409524847876696 },
            { lng: 3.6382589046464773, lat: 15.568119818580456 },
            { lng: 3.7234216650634835, lat: 16.184283759012615 },
            { lng: 4.2702099951438015, lat: 16.852227484601215 },
            { lng: 4.267419467800039, lat: 19.155265204337 },
            { lng: 3.158133172222705, lat: 19.057364203360038 },
            { lng: 3.1466610042539003, lat: 19.693578599521445 },
            { lng: 2.683588494486429, lat: 19.856230170160117 },
            { lng: 2.06099083823392, lat: 20.142233384679486 },
            { lng: 1.8232275732590324, lat: 20.610809434486043 },
            { lng: -1.5500548974576134, lat: 22.792665920497384 },
            { lng: -4.923337368174231, lat: 24.974574082941 },
            { lng: -6.453786586930335, lat: 24.956590684503425 },
            { lng: -5.9711287093242476, lat: 20.64083344164763 },
            { lng: -5.488522508150439, lat: 16.325102037007966 },
            { lng: -5.315277268891933, lat: 16.20185374599184 },
            { lng: -5.537744309908447, lat: 15.501689764869257 },
            { lng: -9.55023840985939, lat: 15.486496893775438 },
            { lng: -9.700255092802706, lat: 15.264107367407362 },
            { lng: -10.086846482778213, lat: 15.330485744686271 },
            { lng: -10.650791388379417, lat: 15.132745876521426 },
            { lng: -11.349095017939504, lat: 15.411256008358478 },
            { lng: -11.666078253617854, lat: 15.388208319556298 },
            { lng: -11.834207526079467, lat: 14.79909699142894 },
            { lng: -12.170750291380301, lat: 14.616834214735505 },
            { lng: -12.12488745772126, lat: 13.994727484589788 },
            { lng: -11.927716030311615, lat: 13.422075100147396 },
            { lng: -11.55339779300543, lat: 13.141213690641067 },
            { lng: -11.467899135778524, lat: 12.754518947800975 },
            { lng: -11.51394283695059, lat: 12.442987575729418 },
        ],
    ],
    [AfricaCountriesEnum.Mauritania]: [
        [
            { lng: -17.06342322434257, lat: 20.999752102130827 },
            { lng: -16.536323614965468, lat: 20.567866319251493 },
            { lng: -16.277838100641517, lat: 20.0925206568147 },
            { lng: -16.37765112961327, lat: 19.593817246981985 },
            { lng: -16.256883307347167, lat: 19.096715806550307 },
            { lng: -16.14634741867485, lat: 18.108481553616656 },
            { lng: -16.270551723688357, lat: 17.166962795474873 },
            { lng: -16.549707810929064, lat: 16.673892116761962 },
            { lng: -16.463098110407884, lat: 16.13503611903846 },
            { lng: -16.12069007004193, lat: 16.455662543193384 },
            { lng: -15.623666144258692, lat: 16.369337063049812 },
            { lng: -15.135737270558819, lat: 16.587282416240782 },
            { lng: -14.577347581428981, lat: 16.59826365810281 },
            { lng: -14.099521450242179, lat: 16.304302273010492 },
            { lng: -13.435737677453062, lat: 16.03938304286619 },
            { lng: -12.830658331747516, lat: 15.303691514542948 },
            { lng: -12.170750291380301, lat: 14.616834214735505 },
            { lng: -11.834207526079467, lat: 14.79909699142894 },
            { lng: -11.666078253617854, lat: 15.388208319556298 },
            { lng: -11.349095017939504, lat: 15.411256008358478 },
            { lng: -10.650791388379417, lat: 15.132745876521426 },
            { lng: -10.086846482778213, lat: 15.330485744686271 },
            { lng: -9.700255092802706, lat: 15.264107367407362 },
            { lng: -9.55023840985939, lat: 15.486496893775438 },
            { lng: -5.537744309908447, lat: 15.501689764869257 },
            { lng: -5.315277268891933, lat: 16.20185374599184 },
            { lng: -5.488522508150439, lat: 16.325102037007966 },
            { lng: -5.9711287093242476, lat: 20.64083344164763 },
            { lng: -6.453786586930335, lat: 24.956590684503425 },
            { lng: -4.923337368174231, lat: 24.974574082941 },
            { lng: -8.684399786809053, lat: 27.395744126896005 },
            { lng: -8.6872936670174, lat: 25.881056219988906 },
            { lng: -11.96941891117116, lat: 25.933352769468268 },
            { lng: -11.937224493853321, lat: 23.374594224536168 },
            { lng: -12.874221564169575, lat: 23.284832261645178 },
            { lng: -13.118754441774712, lat: 22.771220201096256 },
            { lng: -12.929101935263532, lat: 21.327070624267563 },
            { lng: -16.845193650773993, lat: 21.33332347257488 },
            { lng: -17.06342322434257, lat: 20.999752102130827 },
        ],
    ],
    [AfricaCountriesEnum.Benin]: [
        [
            { lng: 2.6917016943562544, lat: 6.258817246928629 },
            { lng: 2.7490625342002204, lat: 7.870734361192888 },
            { lng: 2.723792758809509, lat: 8.50684540448971 },
            { lng: 2.912308383810256, lat: 9.137607937044322 },
            { lng: 3.2203515967021015, lat: 9.444152533399702 },
            { lng: 3.7054382666259187, lat: 10.063210354040208 },
            { lng: 3.600070021182802, lat: 10.332186184119408 },
            { lng: 3.7971122575117136, lat: 10.734745591673105 },
            { lng: 3.572216424177469, lat: 11.32793935795152 },
            { lng: 3.611180454125559, lat: 11.660167141155968 },
            { lng: 2.8486430192265857, lat: 12.23563589115821 },
            { lng: 2.49016360841793, lat: 12.233052069543675 },
            { lng: 2.1544735042499212, lat: 11.940150051313339 },
            { lng: 1.9359855485198807, lat: 11.641150214072553 },
            { lng: 1.4471781754710662, lat: 11.547719224488858 },
            { lng: 1.2434696793764886, lat: 11.110510769083461 },
            { lng: 0.8995630224740694, lat: 10.99733938236426 },
            { lng: 0.7723356461714843, lat: 10.470808213742359 },
            { lng: 1.0777950374487375, lat: 10.175606594275024 },
            { lng: 1.425060662450136, lat: 9.825395412633 },
            { lng: 1.46304284018467, lat: 9.334624335157088 },
            { lng: 1.664477573258381, lat: 9.12859039960938 },
            { lng: 1.618950636409238, lat: 6.832038072126238 },
            { lng: 1.8652405127123188, lat: 6.142157701029731 },
            { lng: 2.6917016943562544, lat: 6.258817246928629 },
        ],
    ],
    [AfricaCountriesEnum.Niger]: [
        [
            { lng: 14.851300000000037, lat: 22.862950000000126 },
            { lng: 14.143870883855243, lat: 22.491288967371133 },
            { lng: 13.581424594790462, lat: 23.04050608976928 },
            { lng: 11.999505649471613, lat: 23.47166840259645 },
            { lng: 8.572893100629784, lat: 21.565660712159143 },
            { lng: 5.677565952180686, lat: 19.601206976799716 },
            { lng: 4.267419467800039, lat: 19.155265204337 },
            { lng: 4.2702099951438015, lat: 16.852227484601215 },
            { lng: 3.7234216650634835, lat: 16.184283759012615 },
            { lng: 3.6382589046464773, lat: 15.568119818580456 },
            { lng: 2.749992709981484, lat: 15.409524847876696 },
            { lng: 1.3855281917468576, lat: 15.323561102759172 },
            { lng: 1.0157833186984817, lat: 14.96818227788799 },
            { lng: 0.3748922054146817, lat: 14.92890818934613 },
            { lng: 0.29564639649510127, lat: 14.444234930880654 },
            { lng: 0.429927605805517, lat: 13.988733018443924 },
            { lng: 0.9930456884900708, lat: 13.335749620003824 },
            { lng: 1.0241032242974768, lat: 12.851825669806574 },
            { lng: 2.177107781593776, lat: 12.625017808477535 },
            { lng: 2.1544735042499212, lat: 11.940150051313339 },
            { lng: 2.49016360841793, lat: 12.233052069543675 },
            { lng: 2.8486430192265857, lat: 12.23563589115821 },
            { lng: 3.611180454125559, lat: 11.660167141155968 },
            { lng: 3.6806335791258107, lat: 12.552903347214226 },
            { lng: 3.9672827490488487, lat: 12.956108710171575 },
            { lng: 4.107945997747322, lat: 13.531215725147831 },
            { lng: 4.368343540066007, lat: 13.747481594289411 },
            { lng: 5.443058302440136, lat: 13.865923977102227 },
            { lng: 6.445426059605637, lat: 13.492768459522678 },
            { lng: 6.820441928747754, lat: 13.115091254117518 },
            { lng: 7.330746697630019, lat: 13.0980380314612 },
            { lng: 7.804671258178786, lat: 13.343526923063747 },
            { lng: 9.014933302454438, lat: 12.826659247280418 },
            { lng: 9.524928012742947, lat: 12.851102199754479 },
            { lng: 10.114814487354693, lat: 13.27725189864941 },
            { lng: 10.701031935273706, lat: 13.246917832894084 },
            { lng: 10.989593133191534, lat: 13.387322699431195 },
            { lng: 11.527803175511394, lat: 13.328980007373588 },
            { lng: 12.302071160540523, lat: 13.037189032437524 },
            { lng: 13.339201357448491, lat: 13.717837130751656 },
            { lng: 13.633358769584465, lat: 13.725803760168045 },
            { lng: 13.540393507550789, lat: 14.367133693901224 },
            { lng: 13.972170000000006, lat: 15.684370000000058 },
            { lng: 15.247731154041844, lat: 16.627305813050782 },
            { lng: 15.30044111497972, lat: 17.927949937405003 },
            { lng: 15.685740594147774, lat: 19.957180080642388 },
            { lng: 15.903246697664315, lat: 20.387618923417506 },
            { lng: 15.487148064850146, lat: 20.730414537025638 },
            { lng: 15.47106000000008, lat: 21.04845000000006 },
            { lng: 15.096887648181848, lat: 21.30851878507491 },
            { lng: 14.851300000000037, lat: 22.862950000000126 },
        ],
    ],
    [AfricaCountriesEnum.Nigeria]: [
        [
            { lng: 2.6917016943562544, lat: 6.258817246928629 },
            { lng: 3.574180128604553, lat: 6.258300482605719 },
            { lng: 4.325607130560684, lat: 6.2706511499234665 },
            { lng: 5.033574252959369, lat: 5.611802476418234 },
            { lng: 5.3628048030908815, lat: 4.887970689305959 },
            { lng: 5.898172641634687, lat: 4.262453314628985 },
            { lng: 6.6980721370806, lat: 4.240594183769517 },
            { lng: 7.0825964697644395, lat: 4.4646890324032285 },
            { lng: 7.462108188515941, lat: 4.412108262546241 },
            { lng: 8.500287713259695, lat: 4.7719829370268485 },
            { lng: 8.757532993208628, lat: 5.479665839047911 },
            { lng: 9.233162876023044, lat: 6.444490668153335 },
            { lng: 9.522705926154401, lat: 6.453482367372117 },
            { lng: 10.118276808318257, lat: 7.03876963950988 },
            { lng: 10.497375115611419, lat: 7.0553577742755635 },
            { lng: 11.058787876030351, lat: 6.6444267846905944 },
            { lng: 11.74577436691851, lat: 6.981382961449754 },
            { lng: 11.839308709366803, lat: 7.397042344589437 },
            { lng: 12.063946160539558, lat: 7.799808457872302 },
            { lng: 12.218872104550599, lat: 8.305824082874324 },
            { lng: 12.753671502339216, lat: 8.717762762888995 },
            { lng: 12.955467970438974, lat: 9.417771714714704 },
            { lng: 13.167599724997103, lat: 9.640626328973411 },
            { lng: 13.308676385153918, lat: 10.160362046748928 },
            { lng: 13.572949659894562, lat: 10.798565985553566 },
            { lng: 14.415378859116684, lat: 11.572368882692075 },
            { lng: 14.468192172918975, lat: 11.904751695193411 },
            { lng: 14.577177768622533, lat: 12.085360826053503 },
            { lng: 14.181336297266794, lat: 12.483656927943116 },
            { lng: 14.083798222709465, lat: 13.084587242198625 },
            { lng: 13.633358769584465, lat: 13.725803760168045 },
            { lng: 13.339201357448491, lat: 13.717837130751656 },
            { lng: 12.302071160540523, lat: 13.037189032437524 },
            { lng: 11.527803175511394, lat: 13.328980007373588 },
            { lng: 10.989593133191534, lat: 13.387322699431195 },
            { lng: 10.701031935273706, lat: 13.246917832894084 },
            { lng: 10.114814487354693, lat: 13.27725189864941 },
            { lng: 9.524928012742947, lat: 12.851102199754479 },
            { lng: 9.014933302454438, lat: 12.826659247280418 },
            { lng: 7.804671258178786, lat: 13.343526923063747 },
            { lng: 7.330746697630019, lat: 13.0980380314612 },
            { lng: 6.820441928747754, lat: 13.115091254117518 },
            { lng: 6.445426059605637, lat: 13.492768459522678 },
            { lng: 5.443058302440136, lat: 13.865923977102227 },
            { lng: 4.368343540066007, lat: 13.747481594289411 },
            { lng: 4.107945997747322, lat: 13.531215725147831 },
            { lng: 3.9672827490488487, lat: 12.956108710171575 },
            { lng: 3.6806335791258107, lat: 12.552903347214226 },
            { lng: 3.611180454125559, lat: 11.660167141155968 },
            { lng: 3.572216424177469, lat: 11.32793935795152 },
            { lng: 3.7971122575117136, lat: 10.734745591673105 },
            { lng: 3.600070021182802, lat: 10.332186184119408 },
            { lng: 3.7054382666259187, lat: 10.063210354040208 },
            { lng: 3.2203515967021015, lat: 9.444152533399702 },
            { lng: 2.912308383810256, lat: 9.137607937044322 },
            { lng: 2.723792758809509, lat: 8.50684540448971 },
            { lng: 2.7490625342002204, lat: 7.870734361192888 },
            { lng: 2.6917016943562544, lat: 6.258817246928629 },
        ],
    ],
    [AfricaCountriesEnum.Cameroon]: [
        [
            { lng: 14.468319707084465, lat: 13.095288098886034 },
            { lng: 14.083798222709465, lat: 13.084587242198625 },
            { lng: 14.181336297266794, lat: 12.483656927943116 },
            { lng: 14.577177768622533, lat: 12.085360826053503 },
            { lng: 14.468192172918975, lat: 11.904751695193411 },
            { lng: 14.415378859116684, lat: 11.572368882692075 },
            { lng: 13.572949659894562, lat: 10.798565985553566 },
            { lng: 13.308676385153918, lat: 10.160362046748928 },
            { lng: 13.167599724997103, lat: 9.640626328973411 },
            { lng: 12.955467970438974, lat: 9.417771714714704 },
            { lng: 12.753671502339216, lat: 8.717762762888995 },
            { lng: 12.218872104550599, lat: 8.305824082874324 },
            { lng: 12.063946160539558, lat: 7.799808457872302 },
            { lng: 11.839308709366803, lat: 7.397042344589437 },
            { lng: 11.74577436691851, lat: 6.981382961449754 },
            { lng: 11.058787876030351, lat: 6.6444267846905944 },
            { lng: 10.497375115611419, lat: 7.0553577742755635 },
            { lng: 10.118276808318257, lat: 7.03876963950988 },
            { lng: 9.522705926154401, lat: 6.453482367372117 },
            { lng: 9.233162876023044, lat: 6.444490668153335 },
            { lng: 8.757532993208628, lat: 5.479665839047911 },
            { lng: 8.500287713259695, lat: 4.7719829370268485 },
            { lng: 8.48881554529089, lat: 4.495617377129918 },
            { lng: 8.744923943729418, lat: 4.35221527751996 },
            { lng: 8.948115675501072, lat: 3.9041289331171356 },
            { lng: 9.404366896206, lat: 3.734526882335203 },
            { lng: 9.795195753629457, lat: 3.073404445809117 },
            { lng: 9.649158155972628, lat: 2.2838660750377358 },
            { lng: 11.276449008843713, lat: 2.261050930180872 },
            { lng: 11.75166548019979, lat: 2.3267575138399934 },
            { lng: 12.359380323952221, lat: 2.19281220133945 },
            { lng: 12.951333855855609, lat: 2.32161570882694 },
            { lng: 13.075822381246752, lat: 2.2670970727590145 },
            { lng: 14.33781253424658, lat: 2.2278746606494906 },
            { lng: 15.146341993885244, lat: 1.9640147973671844 },
            { lng: 15.940918816805066, lat: 1.7276726342802957 },
            { lng: 16.012852410555354, lat: 2.267639675298085 },
            { lng: 15.907380812247652, lat: 2.557389431158612 },
            { lng: 15.862732374747482, lat: 3.0135372989989833 },
            { lng: 15.405395948964383, lat: 3.33530060466434 },
            { lng: 15.036219516671252, lat: 3.8513672957471243 },
            { lng: 14.950953403389661, lat: 4.210389309094921 },
            { lng: 14.47837243008047, lat: 4.732605495620447 },
            { lng: 14.558935988023507, lat: 5.03059764243153 },
            { lng: 14.459407179429348, lat: 5.4517605656103 },
            { lng: 14.536560092841114, lat: 6.2269587264206905 },
            { lng: 14.776545444404576, lat: 6.408498033062045 },
            { lng: 15.279460483469109, lat: 7.421924546737969 },
            { lng: 15.436091749745742, lat: 7.692812404811889 },
            { lng: 15.120865512765306, lat: 8.382150173369439 },
            { lng: 14.97999555833769, lat: 8.796104234243472 },
            { lng: 14.54446658698177, lat: 8.965861314322268 },
            { lng: 13.954218377344006, lat: 9.549494940626687 },
            { lng: 14.171466098699028, lat: 10.021378282099931 },
            { lng: 14.62720055508106, lat: 9.920919297724538 },
            { lng: 14.909353875394716, lat: 9.992129421422732 },
            { lng: 15.467872755605242, lat: 9.982336737503545 },
            { lng: 14.92356489427496, lat: 10.891325181517473 },
            { lng: 14.9601518083376, lat: 11.555574042197224 },
            { lng: 14.89336000000003, lat: 12.219049999999982 },
        ],
    ],
    [AfricaCountriesEnum.Togo]: [
        [
            { lng: 0.8995630224740694, lat: 10.99733938236426 },
            { lng: 0.023802524423700785, lat: 11.018681748900804 },
            { lng: -0.04978471515994442, lat: 10.706917832883931 },
            { lng: 0.3675799902453889, lat: 10.19121287682718 },
            { lng: 0.3659005061958851, lat: 9.465003973829482 },
            { lng: 0.46119184734212126, lat: 8.677222601756014 },
            { lng: 0.7120292496868785, lat: 8.31246450442383 },
            { lng: 0.4909574723422451, lat: 7.411744289576475 },
            { lng: 0.5703841487748491, lat: 6.914358628767189 },
            { lng: 0.8369311865363329, lat: 6.279978745952149 },
            { lng: 1.0601216976049272, lat: 5.928837388528876 },
            { lng: 1.8652405127123188, lat: 6.142157701029731 },
            { lng: 1.618950636409238, lat: 6.832038072126238 },
            { lng: 1.664477573258381, lat: 9.12859039960938 },
            { lng: 1.46304284018467, lat: 9.334624335157088 },
            { lng: 1.425060662450136, lat: 9.825395412633 },
            { lng: 1.0777950374487375, lat: 10.175606594275024 },
            { lng: 0.7723356461714843, lat: 10.470808213742359 },
            { lng: 0.8995630224740694, lat: 10.99733938236426 },
        ],
    ],
    [AfricaCountriesEnum.Ghana]: [
        [
            { lng: 0.023802524423700785, lat: 11.018681748900804 },
            { lng: -0.43870154458858224, lat: 11.098340969278722 },
            { lng: -0.7615758935481834, lat: 10.936929633015055 },
            { lng: -1.2033577132114317, lat: 11.009819240762738 },
            { lng: -2.9404093082704605, lat: 10.962690334512558 },
            { lng: -2.9638962467471117, lat: 10.395334784380083 },
            { lng: -2.8274963037127065, lat: 9.642460842319778 },
            { lng: -2.562189500326241, lat: 8.219627793811483 },
            { lng: -2.9835849674503265, lat: 7.379704901555513 },
            { lng: -3.244370083011262, lat: 6.250471503113502 },
            { lng: -2.8107014632178395, lat: 5.38905121502411 },
            { lng: -2.856125047202397, lat: 4.994475816259509 },
            { lng: -1.9647065901675944, lat: 4.710462144383371 },
            { lng: -1.0636246402941936, lat: 5.000547797053812 },
            { lng: -0.5076379052659377, lat: 5.3434726017426755 },
            { lng: 1.0601216976049272, lat: 5.928837388528876 },
            { lng: 0.8369311865363329, lat: 6.279978745952149 },
            { lng: 0.5703841487748491, lat: 6.914358628767189 },
            { lng: 0.4909574723422451, lat: 7.411744289576475 },
            { lng: 0.7120292496868785, lat: 8.31246450442383 },
            { lng: 0.46119184734212126, lat: 8.677222601756014 },
            { lng: 0.3659005061958851, lat: 9.465003973829482 },
            { lng: 0.3675799902453889, lat: 10.19121287682718 },
            { lng: -0.04978471515994442, lat: 10.706917832883931 },
            { lng: 0.023802524423700785, lat: 11.018681748900804 },
        ],
    ],
    [AfricaCountriesEnum.CoteDIvoire]: [
        [
            { lng: -8.029943610048619, lat: 10.206534939001713 },
            { lng: -8.229337124046822, lat: 10.1290202905639 },
            { lng: -8.30961646161225, lat: 9.789531968622441 },
            { lng: -8.07911373537435, lat: 9.376223863152035 },
            { lng: -7.832100389019188, lat: 8.575704250518626 },
            { lng: -8.20349890790088, lat: 8.455453192575447 },
            { lng: -8.299048631208564, lat: 8.316443589710303 },
            { lng: -8.221792364932199, lat: 8.123328762235573 },
            { lng: -8.280703497744938, lat: 7.687179673692157 },
            { lng: -8.439298468448698, lat: 7.686042792181738 },
            { lng: -8.48544552248535, lat: 7.39520783124307 },
            { lng: -8.385451626000574, lat: 6.911800645368743 },
            { lng: -8.60288021486862, lat: 6.4675641951716605 },
            { lng: -8.311347622094019, lat: 6.193033148621083 },
            { lng: -7.993692592795881, lat: 6.126189683451543 },
            { lng: -7.570152553731688, lat: 5.707352199725904 },
            { lng: -7.539715135111763, lat: 5.313345241716519 },
            { lng: -7.635368211284031, lat: 5.188159084489456 },
            { lng: -7.7121593896697505, lat: 4.364565944837722 },
            { lng: -7.5189412093304355, lat: 4.338288479017308 },
            { lng: -6.528769090185847, lat: 4.705087795425015 },
            { lng: -5.8344962223445265, lat: 4.993700669775137 },
            { lng: -4.649917364917911, lat: 5.168263658057086 },
            { lng: -4.008819545904942, lat: 5.179813340674315 },
            { lng: -3.3110843571000714, lat: 4.984295559098015 },
            { lng: -2.856125047202397, lat: 4.994475816259509 },
            { lng: -2.8107014632178395, lat: 5.38905121502411 },
            { lng: -3.244370083011262, lat: 6.250471503113502 },
            { lng: -2.9835849674503265, lat: 7.379704901555513 },
            { lng: -2.562189500326241, lat: 8.219627793811483 },
            { lng: -2.8274963037127065, lat: 9.642460842319778 },
            { lng: -3.511898972986273, lat: 9.90032623945622 },
            { lng: -3.9804491845766847, lat: 9.8623440617217 },
            { lng: -4.3302469547603835, lat: 9.610834865757141 },
            { lng: -4.7798835921319665, lat: 9.821984768101743 },
            { lng: -4.954653286143099, lat: 10.152713934769736 },
            { lng: -5.404341599946974, lat: 10.370736802609146 },
            { lng: -5.816926235365287, lat: 10.222554633012194 },
            { lng: -6.050452032892267, lat: 10.096360785355444 },
            { lng: -6.205222947606431, lat: 10.524060777219134 },
            { lng: -6.493965013037268, lat: 10.411302801958271 },
            { lng: -6.666460944027548, lat: 10.430810655148449 },
            { lng: -6.8505065576350574, lat: 10.138993841996239 },
            { lng: -7.622759161804809, lat: 10.147236232946796 },
            { lng: -7.899589809592372, lat: 10.297382106970828 },
            { lng: -8.029943610048619, lat: 10.206534939001713 },
        ],
    ],
    [AfricaCountriesEnum.Guinea]: [
        [
            { lng: -13.700476040084325, lat: 12.586182969610194 },
            { lng: -13.718743658899513, lat: 12.24718557377551 },
            { lng: -13.828271857142125, lat: 12.142644151249044 },
            { lng: -13.743160773157413, lat: 11.811269029177412 },
            { lng: -13.900799729863776, lat: 11.678718980348748 },
            { lng: -14.121406419317779, lat: 11.677117010947697 },
            { lng: -14.382191534878729, lat: 11.509271958863692 },
            { lng: -14.685687221728898, lat: 11.527823798056488 },
            { lng: -15.130311245168173, lat: 11.040411688679526 },
            { lng: -14.839553798877944, lat: 10.87657156009814 },
            { lng: -14.693231980843505, lat: 10.656300767454042 },
            { lng: -14.579698859098258, lat: 10.214467271358515 },
            { lng: -14.33007585291237, lat: 10.015719712763968 },
            { lng: -14.074044969122282, lat: 9.886166897008252 },
            { lng: -13.685153977909792, lat: 9.49474376061346 },
            { lng: -13.246550258832515, lat: 8.903048610871508 },
            { lng: -12.71195756677308, lat: 9.342711696810767 },
            { lng: -12.59671912276221, lat: 9.62018830000197 },
            { lng: -12.425928514037565, lat: 9.835834051955956 },
            { lng: -12.150338100625005, lat: 9.858571682164381 },
            { lng: -11.917277390988659, lat: 10.046983954300558 },
            { lng: -11.11748124840733, lat: 10.045872911006285 },
            { lng: -10.839151984083301, lat: 9.688246161330369 },
            { lng: -10.622395188835041, lat: 9.267910061068278 },
            { lng: -10.654770473665891, lat: 8.977178452994195 },
            { lng: -10.494315151399633, lat: 8.715540676300435 },
            { lng: -10.505477260774668, lat: 8.348896389189605 },
            { lng: -10.23009355309128, lat: 8.406205552601293 },
            { lng: -10.016566534861255, lat: 8.428503933135232 },
            { lng: -9.755342169625834, lat: 8.541055202666925 },
            { lng: -9.337279832384581, lat: 7.9285344507113535 },
            { lng: -9.40334815106975, lat: 7.526905218938907 },
            { lng: -9.208786383490846, lat: 7.313920803247953 },
            { lng: -8.926064622422004, lat: 7.309037380396376 },
            { lng: -8.722123582382125, lat: 7.71167430259851 },
            { lng: -8.439298468448698, lat: 7.686042792181738 },
            { lng: -8.280703497744938, lat: 7.687179673692157 },
            { lng: -8.221792364932199, lat: 8.123328762235573 },
            { lng: -8.299048631208564, lat: 8.316443589710303 },
            { lng: -8.20349890790088, lat: 8.455453192575447 },
            { lng: -7.832100389019188, lat: 8.575704250518626 },
            { lng: -8.07911373537435, lat: 9.376223863152035 },
            { lng: -8.30961646161225, lat: 9.789531968622441 },
            { lng: -8.229337124046822, lat: 10.1290202905639 },
            { lng: -8.029943610048619, lat: 10.206534939001713 },
            { lng: -8.33537716310974, lat: 10.494811916541934 },
            { lng: -8.282357143578281, lat: 10.792597357623846 },
            { lng: -8.407310756860028, lat: 10.909256903522762 },
            { lng: -8.620321010767128, lat: 10.810890814655183 },
            { lng: -8.581305304386774, lat: 11.136245632364805 },
            { lng: -8.376304897484914, lat: 11.393645941610629 },
            { lng: -8.786099005559464, lat: 11.812560939984706 },
            { lng: -8.90526485842453, lat: 12.088358059126437 },
            { lng: -9.127473517279583, lat: 12.308060411015333 },
            { lng: -9.327616339546012, lat: 12.334286200403454 },
            { lng: -9.567911749703214, lat: 12.194243068892476 },
            { lng: -9.890992804392013, lat: 12.060478623904972 },
            { lng: -10.165213792348837, lat: 11.844083563682744 },
            { lng: -10.593223842806282, lat: 11.92397532800598 },
            { lng: -10.870829637078215, lat: 12.17788747807211 },
            { lng: -11.03655595543826, lat: 12.211244615116515 },
            { lng: -11.297573614944511, lat: 12.077971096235771 },
            { lng: -11.456168585648271, lat: 12.076834214725338 },
            { lng: -11.51394283695059, lat: 12.442987575729418 },
            { lng: -11.658300950557932, lat: 12.386582749882836 },
            { lng: -12.203564825885634, lat: 12.465647691289405 },
            { lng: -12.27859900557344, lat: 12.354440008997287 },
            { lng: -12.499050665730564, lat: 12.332089952031057 },
            { lng: -13.217818162478238, lat: 12.575873521367967 },
            { lng: -13.700476040084325, lat: 12.586182969610194 },
        ],
    ],
    [AfricaCountriesEnum.GuineaBissau]: [
        [
            { lng: -16.677451951554573, lat: 12.384851589401052 },
            { lng: -16.61383826340328, lat: 12.170911159712702 },
            { lng: -16.30894731288123, lat: 11.95870189050612 },
            { lng: -16.314786749730203, lat: 11.80651479740655 },
            { lng: -16.085214199273565, lat: 11.52459402103824 },
            { lng: -15.664180467175527, lat: 11.458474025920795 },
            { lng: -15.130311245168173, lat: 11.040411688679526 },
            { lng: -14.685687221728898, lat: 11.527823798056488 },
            { lng: -14.382191534878729, lat: 11.509271958863692 },
            { lng: -14.121406419317779, lat: 11.677117010947697 },
            { lng: -13.900799729863776, lat: 11.678718980348748 },
            { lng: -13.743160773157413, lat: 11.811269029177412 },
            { lng: -13.828271857142125, lat: 12.142644151249044 },
            { lng: -13.718743658899513, lat: 12.24718557377551 },
            { lng: -13.700476040084325, lat: 12.586182969610194 },
            { lng: -15.54847693527401, lat: 12.628170070847347 },
            { lng: -15.816574266004254, lat: 12.515567124883347 },
            { lng: -16.147716844130585, lat: 12.547761542201187 },
            { lng: -16.677451951554573, lat: 12.384851589401052 },
        ],
    ],
    [AfricaCountriesEnum.Liberia]: [
        [
            { lng: -8.439298468448698, lat: 7.686042792181738 },
            { lng: -8.722123582382125, lat: 7.71167430259851 },
            { lng: -8.926064622422004, lat: 7.309037380396376 },
            { lng: -9.208786383490846, lat: 7.313920803247953 },
            { lng: -9.40334815106975, lat: 7.526905218938907 },
            { lng: -9.337279832384581, lat: 7.9285344507113535 },
            { lng: -9.755342169625834, lat: 8.541055202666925 },
            { lng: -10.016566534861255, lat: 8.428503933135232 },
            { lng: -10.23009355309128, lat: 8.406205552601293 },
            { lng: -10.69559485517648, lat: 7.939464016141088 },
            { lng: -11.146704270868383, lat: 7.396706447779536 },
            { lng: -11.19980180504828, lat: 7.1058456486247366 },
            { lng: -11.438779466182055, lat: 6.7859168563057475 },
            { lng: -10.765383876986645, lat: 6.140710760925558 },
            { lng: -9.913420376006684, lat: 5.593560695819207 },
            { lng: -9.004793667018674, lat: 4.8324185245922 },
            { lng: -7.974107224957251, lat: 4.355755113131963 },
            { lng: -7.7121593896697505, lat: 4.364565944837722 },
            { lng: -7.635368211284031, lat: 5.188159084489456 },
            { lng: -7.539715135111763, lat: 5.313345241716519 },
            { lng: -7.570152553731688, lat: 5.707352199725904 },
            { lng: -7.993692592795881, lat: 6.126189683451543 },
            { lng: -8.311347622094019, lat: 6.193033148621083 },
            { lng: -8.60288021486862, lat: 6.4675641951716605 },
            { lng: -8.385451626000574, lat: 6.911800645368743 },
            { lng: -8.48544552248535, lat: 7.39520783124307 },
            { lng: -8.439298468448698, lat: 7.686042792181738 },
        ],
    ],
    [AfricaCountriesEnum.SierraLeone]: [
        [
            { lng: -13.246550258832515, lat: 8.903048610871508 },
            { lng: -13.124025437868482, lat: 8.163946438016978 },
            { lng: -12.949049038128194, lat: 7.798645738145738 },
            { lng: -12.428098924193819, lat: 7.26294200279203 },
            { lng: -11.70819454593574, lat: 6.860098374860726 },
            { lng: -11.438779466182055, lat: 6.7859168563057475 },
            { lng: -11.19980180504828, lat: 7.1058456486247366 },
            { lng: -11.146704270868383, lat: 7.396706447779536 },
            { lng: -10.69559485517648, lat: 7.939464016141088 },
            { lng: -10.23009355309128, lat: 8.406205552601293 },
            { lng: -10.505477260774668, lat: 8.348896389189605 },
            { lng: -10.494315151399633, lat: 8.715540676300435 },
            { lng: -10.654770473665891, lat: 8.977178452994195 },
            { lng: -10.622395188835041, lat: 9.267910061068278 },
            { lng: -10.839151984083301, lat: 9.688246161330369 },
            { lng: -11.11748124840733, lat: 10.045872911006285 },
            { lng: -11.917277390988659, lat: 10.046983954300558 },
            { lng: -12.150338100625005, lat: 9.858571682164381 },
            { lng: -12.425928514037565, lat: 9.835834051955956 },
            { lng: -12.59671912276221, lat: 9.62018830000197 },
            { lng: -12.71195756677308, lat: 9.342711696810767 },
            { lng: -13.246550258832515, lat: 8.903048610871508 },
        ],
    ],
    [AfricaCountriesEnum.BurkinaFaso]: [
        [
            { lng: -5.404341599946974, lat: 10.370736802609146 },
            { lng: -4.954653286143099, lat: 10.152713934769736 },
            { lng: -4.7798835921319665, lat: 9.821984768101743 },
            { lng: -4.3302469547603835, lat: 9.610834865757141 },
            { lng: -3.9804491845766847, lat: 9.8623440617217 },
            { lng: -3.511898972986273, lat: 9.90032623945622 },
            { lng: -2.8274963037127065, lat: 9.642460842319778 },
            { lng: -2.9638962467471117, lat: 10.395334784380083 },
            { lng: -2.9404093082704605, lat: 10.962690334512558 },
            { lng: -1.2033577132114317, lat: 11.009819240762738 },
            { lng: -0.7615758935481834, lat: 10.936929633015055 },
            { lng: -0.43870154458858224, lat: 11.098340969278722 },
            { lng: 0.023802524423700785, lat: 11.018681748900804 },
            { lng: 0.8995630224740694, lat: 10.99733938236426 },
            { lng: 1.2434696793764886, lat: 11.110510769083461 },
            { lng: 1.4471781754710662, lat: 11.547719224488858 },
            { lng: 1.9359855485198807, lat: 11.641150214072553 },
            { lng: 2.1544735042499212, lat: 11.940150051313339 },
            { lng: 2.177107781593776, lat: 12.625017808477535 },
            { lng: 1.0241032242974768, lat: 12.851825669806574 },
            { lng: 0.9930456884900708, lat: 13.335749620003824 },
            { lng: 0.429927605805517, lat: 13.988733018443924 },
            { lng: 0.29564639649510127, lat: 14.444234930880654 },
            { lng: 0.3748922054146817, lat: 14.92890818934613 },
            { lng: -0.2662572900305804, lat: 14.924308986872148 },
            { lng: -0.5158544580003479, lat: 15.116157741755728 },
            { lng: -1.0663634912056636, lat: 14.973815009007765 },
            { lng: -2.001035122068771, lat: 14.559008287000893 },
            { lng: -2.1918245100903846, lat: 14.246417548067356 },
            { lng: -2.9676944645205765, lat: 13.79815033615151 },
            { lng: -3.1037068343127596, lat: 13.541266791228594 },
            { lng: -3.522802700199861, lat: 13.337661647998615 },
            { lng: -4.006390753587226, lat: 13.472485459848116 },
            { lng: -4.28040503581488, lat: 13.228443508349741 },
            { lng: -4.427166103523803, lat: 12.542645575404295 },
            { lng: -5.220941941743121, lat: 11.713858954307227 },
            { lng: -5.1978425765086484, lat: 11.37514577885014 },
            { lng: -5.470564947929006, lat: 10.951269842976048 },
            { lng: -5.404341599946974, lat: 10.370736802609146 },
        ],
    ],
    [AfricaCountriesEnum.CentAfrRep]: [
        [
            { lng: 27.37422610851749, lat: 5.233944403500061 },
            { lng: 27.21340905122517, lat: 5.5509534773945575 },
            { lng: 26.465909458123235, lat: 5.9467174341018705 },
            { lng: 26.213418409945117, lat: 6.546603298362072 },
            { lng: 25.79664798351118, lat: 6.979315904158071 },
            { lng: 25.124130893664727, lat: 7.500085150579437 },
            { lng: 25.11493248871679, lat: 7.825104071479174 },
            { lng: 24.567369012152085, lat: 8.229187933785468 },
            { lng: 23.805813429466752, lat: 8.666318874542526 },
            { lng: 23.459012892355986, lat: 8.954285793488893 },
            { lng: 23.394779087017184, lat: 9.265067857292223 },
            { lng: 23.55724979014283, lat: 9.681218166538684 },
            { lng: 23.554304233502194, lat: 10.089255275915308 },
            { lng: 22.97754357269261, lat: 10.71446259199854 },
            { lng: 22.864165480244225, lat: 11.142395127807546 },
            { lng: 22.23112918466876, lat: 10.97188873946061 },
            { lng: 21.723821648859456, lat: 10.567055568885976 },
            { lng: 21.000868361096167, lat: 9.475985215691509 },
            { lng: 20.05968549976427, lat: 9.012706000194854 },
            { lng: 19.09400800952602, lat: 9.07484691002584 },
            { lng: 18.812009718509273, lat: 8.982914536978598 },
            { lng: 18.911021762780507, lat: 8.630894680206353 },
            { lng: 18.38955488452322, lat: 8.281303615751824 },
            { lng: 17.964929640380888, lat: 7.890914008002994 },
            { lng: 16.705988396886255, lat: 7.5083275415299795 },
            { lng: 16.456184523187346, lat: 7.734773667832968 },
            { lng: 16.290561557691888, lat: 7.754307359239419 },
            { lng: 16.106231723706742, lat: 7.497087917506462 },
            { lng: 15.279460483469109, lat: 7.421924546737969 },
            { lng: 14.776545444404576, lat: 6.408498033062045 },
            { lng: 14.536560092841114, lat: 6.2269587264206905 },
            { lng: 14.459407179429348, lat: 5.4517605656103 },
            { lng: 14.558935988023507, lat: 5.03059764243153 },
            { lng: 14.47837243008047, lat: 4.732605495620447 },
            { lng: 14.950953403389661, lat: 4.210389309094921 },
            { lng: 15.036219516671252, lat: 3.8513672957471243 },
            { lng: 15.405395948964383, lat: 3.33530060466434 },
            { lng: 15.862732374747482, lat: 3.0135372989989833 },
            { lng: 15.907380812247652, lat: 2.557389431158612 },
            { lng: 16.012852410555354, lat: 2.267639675298085 },
            { lng: 16.537058139724138, lat: 3.198254706226279 },
            { lng: 17.133042433346304, lat: 3.728196519379452 },
            { lng: 17.809900343505262, lat: 3.5601964379985698 },
            { lng: 18.45306521980993, lat: 3.5043858911233485 },
            { lng: 18.54298221199778, lat: 4.201785183118318 },
            { lng: 18.93231245288476, lat: 4.709506130385975 },
            { lng: 19.46778364429315, lat: 5.03152781821278 },
            { lng: 20.290679152108936, lat: 4.691677761245288 },
            { lng: 20.927591180106276, lat: 4.322785549329737 },
            { lng: 21.659122755630023, lat: 4.22434194581372 },
            { lng: 22.405123732195538, lat: 4.029160061047321 },
            { lng: 22.70412356943629, lat: 4.633050848810157 },
            { lng: 22.841479526468106, lat: 4.710126247573484 },
            { lng: 23.29721398285014, lat: 4.609693101414223 },
            { lng: 24.410531040146253, lat: 5.10878408448913 },
            { lng: 24.805028924262416, lat: 4.89724660890235 },
            { lng: 25.12883344900328, lat: 4.92724477784779 },
            { lng: 25.278798455514305, lat: 5.170408229997192 },
            { lng: 25.650455356557472, lat: 5.256087754737123 },
            { lng: 26.402760857862543, lat: 5.1508745385908705 },
            { lng: 27.04406538260471, lat: 5.127852688004836 },
            { lng: 27.37422610851749, lat: 5.233944403500061 },
        ],
    ],
    [AfricaCountriesEnum.RepOfCongo]: [
        [
            { lng: 18.45306521980993, lat: 3.5043858911233485 },
            { lng: 17.809900343505262, lat: 3.5601964379985698 },
            { lng: 17.133042433346304, lat: 3.728196519379452 },
            { lng: 16.537058139724138, lat: 3.198254706226279 },
            { lng: 16.012852410555354, lat: 2.267639675298085 },
            { lng: 15.940918816805066, lat: 1.7276726342802957 },
            { lng: 15.146341993885244, lat: 1.9640147973671844 },
            { lng: 14.33781253424658, lat: 2.2278746606494906 },
            { lng: 13.075822381246752, lat: 2.2670970727590145 },
            { lng: 13.003113641012078, lat: 1.8308963077833198 },
            { lng: 13.282631463278818, lat: 1.3141836612968805 },
            { lng: 14.026668735417218, lat: 1.3956773950211527 },
            { lng: 14.276265903386957, lat: 1.1969298364266194 },
            { lng: 13.843320753645656, lat: 0.038757635901149 },
            { lng: 14.316418491277744, lat: -0.5526274552470483 },
            { lng: 14.425455763413595, lat: -1.333406670744971 },
            { lng: 14.299210239324566, lat: -1.998275648612214 },
            { lng: 13.99240726080771, lat: -2.4708049454890997 },
            { lng: 13.109618767965628, lat: -2.4287403296035137 },
            { lng: 12.575284458067642, lat: -1.948511244315135 },
            { lng: 12.495702752338161, lat: -2.391688327650243 },
            { lng: 11.820963575903193, lat: -2.514161472181982 },
            { lng: 11.478038771214303, lat: -2.7656189917142413 },
            { lng: 11.855121697648116, lat: -3.4268706193210505 },
            { lng: 11.093772820691925, lat: -3.978826592630547 },
            { lng: 11.91496300624209, lat: -5.037986748884791 },
            { lng: 12.318607618873926, lat: -4.606230157086188 },
            { lng: 12.620759718484493, lat: -4.438023369976136 },
            { lng: 12.995517205465177, lat: -4.781103203961884 },
            { lng: 13.258240187237048, lat: -4.882957452009165 },
            { lng: 13.600234816144678, lat: -4.50013844159097 },
            { lng: 14.144956088933299, lat: -4.510008640158716 },
            { lng: 14.209034864975223, lat: -4.793092136253598 },
            { lng: 14.582603794013181, lat: -4.97023894615014 },
            { lng: 15.170991652088444, lat: -4.343507175314301 },
            { lng: 15.753540073314753, lat: -3.8551648901560966 },
            { lng: 16.0062895036543, lat: -3.535132744972529 },
            { lng: 15.972803175529151, lat: -2.7123922664536124 },
            { lng: 16.407091912510054, lat: -1.7409270157986825 },
            { lng: 16.865306837642123, lat: -1.2258163387132868 },
            { lng: 17.523716261472856, lat: -0.743830254726987 },
            { lng: 17.638644646889986, lat: -0.4248316381892465 },
            { lng: 17.66355268725468, lat: -0.05808399821381727 },
            { lng: 17.826540154703252, lat: 0.28892324462610475 },
            { lng: 17.774191928791566, lat: 0.8556586775710854 },
            { lng: 17.898835483479587, lat: 1.7418319767282782 },
            { lng: 18.094275750407434, lat: 2.365721543788055 },
            { lng: 18.393792351971143, lat: 2.90044342692822 },
            { lng: 18.45306521980993, lat: 3.5043858911233485 },
        ],
    ],
    [AfricaCountriesEnum.Gabon]: [
        [
            { lng: 11.276449008843713, lat: 2.261050930180872 },
            { lng: 11.285078973036462, lat: 1.0576618514000131 },
            { lng: 9.830284051155644, lat: 1.0678937849937995 },
            { lng: 9.492888624721985, lat: 1.010119533691494 },
            { lng: 9.29135053878369, lat: 0.2686660831676875 },
            { lng: 9.048419630579588, lat: -0.45935149496021666 },
            { lng: 8.830086704146424, lat: -0.7790735815500369 },
            { lng: 8.79799563969317, lat: -1.111301364754496 },
            { lng: 9.40524539555497, lat: -2.144313246269043 },
            { lng: 10.06613528813574, lat: -2.9694825171056816 },
            { lng: 11.093772820691925, lat: -3.978826592630547 },
            { lng: 11.855121697648116, lat: -3.4268706193210505 },
            { lng: 11.478038771214303, lat: -2.7656189917142413 },
            { lng: 11.820963575903193, lat: -2.514161472181982 },
            { lng: 12.495702752338161, lat: -2.391688327650243 },
            { lng: 12.575284458067642, lat: -1.948511244315135 },
            { lng: 13.109618767965628, lat: -2.4287403296035137 },
            { lng: 13.99240726080771, lat: -2.4708049454890997 },
            { lng: 14.299210239324566, lat: -1.998275648612214 },
            { lng: 14.425455763413595, lat: -1.333406670744971 },
            { lng: 14.316418491277744, lat: -0.5526274552470483 },
            { lng: 13.843320753645656, lat: 0.038757635901149 },
            { lng: 14.276265903386957, lat: 1.1969298364266194 },
            { lng: 14.026668735417218, lat: 1.3956773950211527 },
            { lng: 13.282631463278818, lat: 1.3141836612968805 },
            { lng: 13.003113641012078, lat: 1.8308963077833198 },
            { lng: 13.075822381246752, lat: 2.2670970727590145 },
            { lng: 12.951333855855609, lat: 2.32161570882694 },
            { lng: 12.359380323952221, lat: 2.19281220133945 },
            { lng: 11.75166548019979, lat: 2.3267575138399934 },
            { lng: 11.276449008843713, lat: 2.261050930180872 },
        ],
    ],
    [AfricaCountriesEnum.EqGuinea]: [
        [
            { lng: 9.649158155972628, lat: 2.2838660750377358 },
            { lng: 9.305613234096256, lat: 1.1609113631191832 },
            { lng: 9.492888624721985, lat: 1.010119533691494 },
            { lng: 9.830284051155644, lat: 1.0678937849937995 },
            { lng: 11.285078973036462, lat: 1.0576618514000131 },
            { lng: 11.276449008843713, lat: 2.261050930180872 },
            { lng: 9.649158155972628, lat: 2.2838660750377358 },
        ],
    ],
    [AfricaCountriesEnum.Zambia]: [
        [
            { lng: 30.740009731422095, lat: -8.34000593035372 },
            { lng: 30.346086053190817, lat: -8.238256524288218 },
            { lng: 29.00291222506047, lat: -8.407031752153472 },
            { lng: 28.734866570762502, lat: -8.526559340044578 },
            { lng: 28.449871046672826, lat: -9.164918308146085 },
            { lng: 28.67368167492893, lat: -9.605924981324932 },
            { lng: 28.49606977714177, lat: -10.789883721564046 },
            { lng: 28.372253045370428, lat: -11.793646742401393 },
            { lng: 28.642417433392353, lat: -11.971568698782315 },
            { lng: 29.34154788586909, lat: -12.360743910372413 },
            { lng: 29.61600141777123, lat: -12.178894545137311 },
            { lng: 29.69961388521949, lat: -13.257226657771831 },
            { lng: 28.934285922976837, lat: -13.248958428605135 },
            { lng: 28.523561639121027, lat: -12.698604424696683 },
            { lng: 28.155108676879987, lat: -12.272480564017897 },
            { lng: 27.388798862423783, lat: -12.132747491100666 },
            { lng: 27.164419793412463, lat: -11.608748467661075 },
            { lng: 26.553087599399618, lat: -11.924439792532127 },
            { lng: 25.752309604604733, lat: -11.784965101776358 },
            { lng: 25.418118116973204, lat: -11.330935967659961 },
            { lng: 24.78316979340295, lat: -11.238693536018964 },
            { lng: 24.31451622894795, lat: -11.26282642989927 },
            { lng: 24.25715538910399, lat: -10.951992689663657 },
            { lng: 23.912215203555718, lat: -10.926826267137514 },
            { lng: 24.01789350759259, lat: -11.23729827234709 },
            { lng: 23.904153680118185, lat: -11.722281589406322 },
            { lng: 24.079905226342845, lat: -12.191296888887365 },
            { lng: 23.930922072045377, lat: -12.565847670138856 },
            { lng: 24.016136508894675, lat: -12.911046237848574 },
            { lng: 21.933886346125917, lat: -12.898437188369359 },
            { lng: 21.887842644953874, lat: -16.08031015387688 },
            { lng: 22.56247846852426, lat: -16.898451429921813 },
            { lng: 23.215048455506064, lat: -17.523116143465984 },
            { lng: 24.033861525170778, lat: -17.295843194246324 },
            { lng: 24.682349074001507, lat: -17.353410739819473 },
            { lng: 25.07695031098226, lat: -17.57882333747662 },
            { lat: -17.766702551579186, lng: 25.170394897460955 },
            { lng: 25.262336480636822, lat: -17.790922257594097 },
            { lng: 26.381935255648926, lat: -17.8460421688579 },
            { lng: 26.70677330903564, lat: -17.961228936436484 },
            { lng: 27.044427117630732, lat: -17.938026218337434 },
            { lng: 27.59824344250276, lat: -17.290830580314008 },
            { lng: 28.467906121542683, lat: -16.468400160388846 },
            { lng: 28.8258687680285, lat: -16.389748630440614 },
            { lng: 28.947463413211267, lat: -16.04305144619444 },
            { lng: 29.516834344203147, lat: -15.644677829656388 },
            { lng: 30.27425581230511, lat: -15.507786960515213 },
            { lng: 30.17948123548183, lat: -14.796099134991529 },
            { lng: 33.214024692525214, lat: -13.971860039936153 },
            { lng: 32.68816531752313, lat: -13.712857761289277 },
            { lng: 32.991764357237884, lat: -12.783870537978274 },
            { lng: 33.306422153463075, lat: -12.435778090060218 },
            { lng: 33.114289178201915, lat: -11.607198174692314 },
            { lng: 33.315310499817286, lat: -10.796549981329697 },
            { lng: 33.48568769708359, lat: -10.525558770391115 },
            { lng: 33.2313879737753, lat: -9.6767216935648 },
            { lng: 32.75937544122132, lat: -9.23059905358906 },
            { lng: 32.19186486179194, lat: -8.930358981973257 },
            { lng: 31.556348097466497, lat: -8.762048841998642 },
            { lng: 31.15775133695005, lat: -8.594578747317366 },
            { lng: 30.740009731422095, lat: -8.34000593035372 },
        ],
    ],
    [AfricaCountriesEnum.Malawi]: [
        [
            { lng: 32.75937544122132, lat: -9.23059905358906 },
            { lng: 33.2313879737753, lat: -9.6767216935648 },
            { lng: 33.48568769708359, lat: -10.525558770391115 },
            { lng: 33.315310499817286, lat: -10.796549981329697 },
            { lng: 33.114289178201915, lat: -11.607198174692314 },
            { lng: 33.306422153463075, lat: -12.435778090060218 },
            { lng: 32.991764357237884, lat: -12.783870537978274 },
            { lng: 32.68816531752313, lat: -13.712857761289277 },
            { lng: 33.214024692525214, lat: -13.971860039936153 },
            { lng: 33.789700148256685, lat: -14.45183074306307 },
            { lng: 34.064825473778626, lat: -14.35995004644812 },
            { lng: 34.45963341648854, lat: -14.613009535381423 },
            { lng: 34.51766604995231, lat: -15.013708591372612 },
            { lng: 34.307291294092096, lat: -15.478641452702597 },
            { lng: 34.38129194513405, lat: -16.183559665596043 },
            { lng: 35.033810255683534, lat: -16.801299737213093 },
            { lng: 35.339062941231646, lat: -16.10744028083011 },
            { lng: 35.77190473810836, lat: -15.896858819240727 },
            { lng: 35.68684533055594, lat: -14.611045830954332 },
            { lng: 35.26795617039801, lat: -13.887834161029566 },
            { lng: 34.907151320136165, lat: -13.565424899960568 },
            { lng: 34.55998904799935, lat: -13.579997653866876 },
            { lng: 34.28000613784198, lat: -12.280025323132506 },
            { lng: 34.55998904799935, lat: -11.520020033415925 },
            { lng: 34.27999999999997, lat: -10.160000000000025 },
            { lng: 33.940837724096525, lat: -9.693673841980285 },
            { lng: 33.73972000000009, lat: -9.417149999999992 },
            { lng: 32.75937544122132, lat: -9.23059905358906 },
        ],
    ],
    [AfricaCountriesEnum.Mozambique]: [
        [
            { lng: 34.55998904799935, lat: -11.520020033415925 },
            { lng: 34.28000613784198, lat: -12.280025323132506 },
            { lng: 34.55998904799935, lat: -13.579997653866876 },
            { lng: 34.907151320136165, lat: -13.565424899960568 },
            { lng: 35.26795617039801, lat: -13.887834161029566 },
            { lng: 35.68684533055594, lat: -14.611045830954332 },
            { lng: 35.77190473810836, lat: -15.896858819240727 },
            { lng: 35.339062941231646, lat: -16.10744028083011 },
            { lng: 35.033810255683534, lat: -16.801299737213093 },
            { lng: 34.38129194513405, lat: -16.183559665596043 },
            { lng: 34.307291294092096, lat: -15.478641452702597 },
            { lng: 34.51766604995231, lat: -15.013708591372612 },
            { lng: 34.45963341648854, lat: -14.613009535381423 },
            { lng: 34.064825473778626, lat: -14.35995004644812 },
            { lng: 33.789700148256685, lat: -14.45183074306307 },
            { lng: 33.214024692525214, lat: -13.971860039936153 },
            { lng: 30.17948123548183, lat: -14.796099134991529 },
            { lng: 30.27425581230511, lat: -15.507786960515213 },
            { lng: 30.338954705534544, lat: -15.880839125230246 },
            { lng: 31.17306399915768, lat: -15.860943698797874 },
            { lng: 31.636498243951195, lat: -16.071990248277885 },
            { lng: 31.8520406430406, lat: -16.319417006091378 },
            { lng: 32.32823896661023, lat: -16.392074069893752 },
            { lng: 32.847638787575846, lat: -16.713398125884616 },
            { lng: 32.84986087416439, lat: -17.97905730557718 },
            { lng: 32.65488569512715, lat: -18.672089939043495 },
            { lng: 32.61199425632489, lat: -19.419382826416275 },
            { lng: 32.772707960752626, lat: -19.715592136313298 },
            { lng: 32.65974327976258, lat: -20.304290052982317 },
            { lng: 32.50869306817344, lat: -20.395292250248307 },
            { lng: 32.244988234188014, lat: -21.116488539313693 },
            { lng: 31.19140913262129, lat: -22.2515096981724 },
            { lng: 31.670397983534656, lat: -23.658969008073864 },
            { lng: 31.930588820124253, lat: -24.36941659922254 },
            { lng: 31.75240848158188, lat: -25.484283949487413 },
            { lng: 31.83777794772806, lat: -25.84333180105135 },
            { lng: 31.98577924981197, lat: -26.291779880480227 },
            { lng: 32.07166548028107, lat: -26.73382008230491 },
            { lng: 32.830120477028885, lat: -26.742191664336197 },
            { lng: 32.91595503106569, lat: -26.215867201443466 },
            { lng: 32.66036339695009, lat: -26.148584486599447 },
            { lng: 32.574632195777866, lat: -25.727318210556092 },
            { lng: 33.01321007663901, lat: -25.357573337507738 },
            { lng: 34.21582400893547, lat: -24.81631438568266 },
            { lng: 35.04073489761066, lat: -24.478350518493805 },
            { lng: 35.45874555841962, lat: -24.12260995859655 },
            { lng: 35.60747033055563, lat: -23.706563002214683 },
            { lng: 35.37177412287238, lat: -23.5353589820317 },
            { lng: 35.533934767404304, lat: -23.070787855727758 },
            { lng: 35.562545536369086, lat: -22.090000000000003 },
            { lng: 35.385848253705404, lat: -22.14 },
            { lng: 35.37342776870574, lat: -21.840837090748877 },
            { lng: 35.176127150215365, lat: -21.25436126066841 },
            { lng: 34.70189253107284, lat: -20.49704314543101 },
            { lng: 34.78638349787005, lat: -19.784011732667736 },
            { lng: 35.198399692533144, lat: -19.552811374593894 },
            { lng: 35.89649661636406, lat: -18.842260430580637 },
            { lng: 36.28127933120936, lat: -18.65968759529345 },
            { lng: 37.41113284683888, lat: -17.586368096591237 },
            { lng: 38.53835086442152, lat: -17.101023044505958 },
            { lng: 39.45255862809705, lat: -16.72089120856694 },
            { lng: 40.08926395036522, lat: -16.10077402106446 },
            { lng: 40.4772506040126, lat: -15.406294447493972 },
            { lng: 40.775475294768995, lat: -14.691764418194241 },
            { lng: 40.59962039567975, lat: -14.201975192931862 },
            { lng: 40.56081139502857, lat: -12.639176527561027 },
            { lng: 40.437253045418686, lat: -11.761710707245015 },
            { lng: 40.47838748552303, lat: -10.765440769089993 },
            { lng: 40.31658857601719, lat: -10.317096042525698 },
            { lng: 40.316586229110854, lat: -10.317097752817492 },
            { lng: 40.31659000000002, lat: -10.317099999999868 },
            { lng: 39.52099999999996, lat: -10.89688000000001 },
            { lng: 38.42755659358775, lat: -11.285202325081656 },
            { lng: 37.827639999999974, lat: -11.26878999999991 },
            { lng: 37.471289999999954, lat: -11.568759999999997 },
            { lng: 36.775150994622805, lat: -11.594537448780805 },
            { lng: 36.51408165868426, lat: -11.720938002166735 },
            { lng: 35.31239790216904, lat: -11.439146416879147 },
            { lng: 34.55998904799935, lat: -11.520020033415925 },
        ],
    ],
    [AfricaCountriesEnum.Eswatini]: [
        [
            { lng: 32.07166548028107, lat: -26.73382008230491 },
            { lng: 31.98577924981197, lat: -26.291779880480227 },
            { lng: 31.83777794772806, lat: -25.84333180105135 },
            { lng: 31.333157586397903, lat: -25.66019052500895 },
            { lng: 31.04407962415715, lat: -25.731452325139443 },
            { lng: 30.949666782359913, lat: -26.02264902110415 },
            { lng: 30.67660851412964, lat: -26.398078301704608 },
            { lng: 30.68596194837448, lat: -26.743845310169533 },
            { lng: 31.28277306491333, lat: -27.285879408478998 },
            { lng: 31.86806033705108, lat: -27.177927341421277 },
            { lng: 32.07166548028107, lat: -26.73382008230491 },
        ],
    ],
    [AfricaCountriesEnum.Angola]: [
        [
            { lng: 12.995517205465177, lat: -4.781103203961884 },
            { lng: 12.620759718484493, lat: -4.438023369976136 },
            { lng: 12.318607618873926, lat: -4.606230157086188 },
            { lng: 11.91496300624209, lat: -5.037986748884791 },
            { lng: 12.182336866920252, lat: -5.789930515163839 },
            { lng: 12.436688266660868, lat: -5.6843038875592455 },
            { lng: 12.468004184629736, lat: -5.248361504745005 },
            { lng: 12.63161176926579, lat: -4.991271254092936 },
            { lng: 12.995517205465177, lat: -4.781103203961884 },
        ],
        [
            { lng: 12.32243167486351, lat: -6.10009246177966 },
            { lng: 12.227347039446471, lat: -6.294447523629394 },
            { lng: 12.728298374083892, lat: -6.927122084178805 },
            { lng: 12.93304039882429, lat: -7.596538588087733 },
            { lng: 13.236432732809874, lat: -8.562629489784307 },
            { lng: 12.92906131353783, lat: -8.959091078327553 },
            { lng: 12.875369500386569, lat: -9.166933689005468 },
            { lng: 13.120987583069846, lat: -9.766897067914122 },
            { lng: 13.387327915102162, lat: -10.373578383020714 },
            { lng: 13.686379428775238, lat: -10.73107594161589 },
            { lng: 13.738727654686897, lat: -11.297863050993165 },
            { lng: 13.6337211442698, lat: -12.03864470789717 },
            { lng: 13.312913852601866, lat: -12.483630466362492 },
            { lng: 12.738478631245385, lat: -13.137905775609902 },
            { lng: 12.50009524908299, lat: -13.54769988368445 },
            { lng: 12.175618930722294, lat: -14.449143568583892 },
            { lng: 12.12358076340439, lat: -14.878316338767904 },
            { lng: 11.778537224991537, lat: -15.793816013250735 },
            { lng: 11.64009606288161, lat: -16.67314218512925 },
            { lng: 11.734198846085121, lat: -17.301889336824473 },
            { lng: 12.215461460019355, lat: -17.111668389558083 },
            { lng: 12.814081251688407, lat: -16.94134286872407 },
            { lng: 13.462362094789967, lat: -16.971211846588773 },
            { lng: 14.05850141770901, lat: -17.423380629142663 },
            { lng: 14.209706658595024, lat: -17.35310068122572 },
            { lng: 18.263309360434164, lat: -17.309950860262006 },
            { lng: 18.956186964603603, lat: -17.789094740472258 },
            { lng: 21.377176141045567, lat: -17.930636488519696 },
            { lng: 23.215048455506064, lat: -17.523116143465984 },
            { lng: 22.56247846852426, lat: -16.898451429921813 },
            { lng: 21.887842644953874, lat: -16.08031015387688 },
            { lng: 21.933886346125917, lat: -12.898437188369359 },
            { lng: 24.016136508894675, lat: -12.911046237848574 },
            { lng: 23.930922072045377, lat: -12.565847670138856 },
            { lng: 24.079905226342845, lat: -12.191296888887365 },
            { lng: 23.904153680118185, lat: -11.722281589406322 },
            { lng: 24.01789350759259, lat: -11.23729827234709 },
            { lng: 23.912215203555718, lat: -10.926826267137514 },
            { lng: 23.45679080576744, lat: -10.867863457892483 },
            { lng: 22.83734541188474, lat: -11.01762175867433 },
            { lng: 22.402798292742375, lat: -10.993075453335692 },
            { lng: 22.155268182064308, lat: -11.084801120653772 },
            { lng: 22.208753289486395, lat: -9.894796237836509 },
            { lng: 21.875181919042348, lat: -9.523707777548566 },
            { lng: 21.8018013851879, lat: -8.90870655684298 },
            { lng: 21.949130893652043, lat: -8.305900974158277 },
            { lng: 21.74645592620331, lat: -7.920084730667149 },
            { lng: 21.7281107927397, lat: -7.290872491081302 },
            { lng: 20.5147481625265, lat: -7.2996058081386295 },
            { lng: 20.6018229509383, lat: -6.939317722199682 },
            { lng: 20.091621534920648, lat: -6.943090101756994 },
            { lng: 20.037723016040218, lat: -7.116361179231646 },
            { lng: 19.41750247567316, lat: -7.155428562044299 },
            { lng: 19.16661339689611, lat: -7.738183688999754 },
            { lng: 19.01675174324967, lat: -7.988245944860132 },
            { lng: 18.464175652752687, lat: -7.847014255406443 },
            { lng: 18.13422163256905, lat: -7.987677504104923 },
            { lng: 17.472970004962235, lat: -8.0685511206417 },
            { lng: 17.08999596524717, lat: -7.545688978712526 },
            { lng: 16.8601908708452, lat: -7.2222978654299865 },
            { lng: 16.573179965896145, lat: -6.6226445451150875 },
            { lng: 16.326528354567046, lat: -5.877470391466268 },
            { lng: 13.375597364971895, lat: -5.8642412247995495 },
            { lng: 13.024869419006961, lat: -5.984388929878158 },
            { lng: 12.735171339578699, lat: -5.965682061388499 },
            { lng: 12.32243167486351, lat: -6.10009246177966 },
        ],
    ],
    [AfricaCountriesEnum.Burundi]: [
        [
            { lng: 30.469673645761223, lat: -2.41385475710134 },
            { lng: 29.93835900240794, lat: -2.348486830254238 },
            { lng: 29.632176141078588, lat: -2.917857761246097 },
            { lng: 29.024926385216787, lat: -2.8392579077301576 },
            { lng: 29.276383904749053, lat: -3.293907159034063 },
            { lng: 29.339997592900346, lat: -4.4999834122940925 },
            { lng: 29.753512404099865, lat: -4.452389418153302 },
            { lng: 30.11632000000003, lat: -4.090120000000013 },
            { lng: 30.505539999999996, lat: -3.5685799999999404 },
            { lng: 30.752240000000086, lat: -3.3593099999999936 },
            { lng: 30.743010000000027, lat: -3.034309999999948 },
            { lng: 30.527660000000026, lat: -2.807619999999986 },
            { lng: 30.469673645761223, lat: -2.41385475710134 },
        ],
    ],
    [AfricaCountriesEnum.Gambia]: [
        [
            { lng: -16.71372880702347, lat: 13.594958604379855 },
            { lng: -16.841524624081273, lat: 13.15139394780256 },
            { lng: -15.931295945692211, lat: 13.130284125211332 },
            { lng: -15.691000535534995, lat: 13.270353094938457 },
            { lng: -15.511812506562933, lat: 13.278569647672867 },
            { lng: -15.141163295949468, lat: 13.509511623585238 },
            { lng: -14.712197231494628, lat: 13.298206691943777 },
            { lng: -14.277701788784555, lat: 13.280585028532244 },
            { lng: -13.844963344772408, lat: 13.505041612192002 },
            { lng: -14.046992356817482, lat: 13.79406789800045 },
            { lng: -14.376713833055788, lat: 13.625680243377374 },
            { lng: -14.687030808968487, lat: 13.630356960499784 },
            { lng: -15.08173539881382, lat: 13.876491807505985 },
            { lng: -15.39877031092446, lat: 13.86036876063092 },
            { lng: -15.624596320039942, lat: 13.62358734786956 },
            { lng: -16.71372880702347, lat: 13.594958604379855 },
        ],
    ],
    [AfricaCountriesEnum.Tunisia]: [
        [
            { lng: 9.482139926805274, lat: 30.307556057246188 },
            { lng: 9.970017124072854, lat: 30.53932485607524 },
            { lng: 10.056575148161699, lat: 30.961831366493527 },
            { lng: 9.950225050505082, lat: 31.376069647745258 },
            { lng: 10.636901482799487, lat: 31.761420803345757 },
            { lng: 10.944789666394456, lat: 32.081814683555365 },
            { lng: 11.432253452203696, lat: 32.368903103152874 },
            { lng: 11.488787469131012, lat: 33.13699575452324 },
            { lng: 11.108500603895122, lat: 33.293342800422195 },
            { lng: 10.856836378633687, lat: 33.76874013929128 },
            { lng: 10.339658644256616, lat: 33.78574168551532 },
            { lng: 10.149592726287125, lat: 34.33077301689771 },
            { lng: 10.807847120821009, lat: 34.83350718844919 },
            { lng: 10.939518670300687, lat: 35.698984076473494 },
            { lng: 10.593286573945138, lat: 35.94744436293281 },
            { lng: 10.600004510143094, lat: 36.410000108377375 },
            { lng: 11.100025668999251, lat: 36.899996039368915 },
            { lng: 11.02886722173335, lat: 37.09210317641396 },
            { lng: 10.180650262094531, lat: 36.724037787415085 },
            { lng: 10.210002475636317, lat: 37.230001735984814 },
            { lng: 9.509993523810607, lat: 37.349994411766545 },
            { lng: 8.420964389691676, lat: 36.94642731378316 },
            { lng: 8.217824334352315, lat: 36.433176988260286 },
            { lng: 8.376367628623768, lat: 35.479876003555944 },
            { lng: 8.140981479534304, lat: 34.65514598239379 },
            { lng: 7.524481642292244, lat: 34.09737641045146 },
            { lng: 7.6126416357821824, lat: 33.34411489514896 },
            { lng: 8.430472853233368, lat: 32.74833730725595 },
            { lng: 8.439102817426118, lat: 32.50628489840082 },
            { lng: 9.05560265466815, lat: 32.10269196220129 },
            { lng: 9.482139926805274, lat: 30.307556057246188 },
        ],
    ],
    [AfricaCountriesEnum.Algeria]: [
        [
            { lng: -8.684399786809053, lat: 27.395744126896005 },
            { lng: -4.923337368174231, lat: 24.974574082941 },
            { lng: -1.5500548974576134, lat: 22.792665920497384 },
            { lng: 1.8232275732590324, lat: 20.610809434486043 },
            { lng: 2.06099083823392, lat: 20.142233384679486 },
            { lng: 2.683588494486429, lat: 19.856230170160117 },
            { lng: 3.1466610042539003, lat: 19.693578599521445 },
            { lng: 3.158133172222705, lat: 19.057364203360038 },
            { lng: 4.267419467800039, lat: 19.155265204337 },
            { lng: 5.677565952180686, lat: 19.601206976799716 },
            { lng: 8.572893100629784, lat: 21.565660712159143 },
            { lng: 11.999505649471613, lat: 23.47166840259645 },
            { lng: 11.560669386449005, lat: 24.097909247325518 },
            { lng: 10.771363559622927, lat: 24.56253205006175 },
            { lng: 10.303846876678362, lat: 24.379313259370917 },
            { lng: 9.94826134607797, lat: 24.936953640232517 },
            { lng: 9.910692579801776, lat: 25.365454616796796 },
            { lng: 9.319410841518163, lat: 26.094324856057455 },
            { lng: 9.716285841519664, lat: 26.512206325785655 },
            { lng: 9.629056023811074, lat: 27.14095347748092 },
            { lng: 9.756128370816782, lat: 27.688258571884205 },
            { lng: 9.683884718472768, lat: 28.1441738957792 },
            { lng: 9.859997999723447, lat: 28.959989732371014 },
            { lng: 9.805634392952356, lat: 29.424638373323376 },
            { lng: 9.482139926805274, lat: 30.307556057246188 },
            { lng: 9.05560265466815, lat: 32.10269196220129 },
            { lng: 8.439102817426118, lat: 32.50628489840082 },
            { lng: 8.430472853233368, lat: 32.74833730725595 },
            { lng: 7.6126416357821824, lat: 33.34411489514896 },
            { lng: 7.524481642292244, lat: 34.09737641045146 },
            { lng: 8.140981479534304, lat: 34.65514598239379 },
            { lng: 8.376367628623768, lat: 35.479876003555944 },
            { lng: 8.217824334352315, lat: 36.433176988260286 },
            { lng: 8.420964389691676, lat: 36.94642731378316 },
            { lng: 7.737078484741005, lat: 36.885707505840216 },
            { lng: 7.330384962603971, lat: 37.11838064223437 },
            { lng: 6.261819695672613, lat: 37.11065501560674 },
            { lng: 5.3201200700177935, lat: 36.71651886651662 },
            { lng: 4.81575809084913, lat: 36.86503693292346 },
            { lng: 3.1616988460508253, lat: 36.78390493422522 },
            { lng: 1.466918572606545, lat: 36.605647081034405 },
            { lng: 0.5038765804152092, lat: 36.30127289483528 },
            { lng: -0.12745439289460592, lat: 35.888662421200806 },
            { lng: -1.208602871089056, lat: 35.7148487411871 },
            { lng: -2.169913702798624, lat: 35.16839630791668 },
            { lng: -1.792985805661715, lat: 34.527918606091305 },
            { lng: -1.7334545556614671, lat: 33.91971283623212 },
            { lng: -1.388049282222596, lat: 32.86401500094138 },
            { lng: -1.1245511539663084, lat: 32.65152151135713 },
            { lng: -1.30789913573787, lat: 32.2628889023061 },
            { lng: -2.616604783529567, lat: 32.09434621838619 },
            { lng: -3.068980271812648, lat: 31.724497992473218 },
            { lng: -3.647497931320146, lat: 31.637294012980675 },
            { lng: -3.6904410465547244, lat: 30.896951605751156 },
            { lng: -4.859646165374471, lat: 30.501187649043846 },
            { lng: -5.242129278982787, lat: 30.00044302013559 },
            { lng: -6.060632290053774, lat: 29.731699734001694 },
            { lng: -7.059227667661958, lat: 29.5792284205246 },
            { lng: -8.674116176782974, lat: 28.84128896739658 },
            { lng: -8.665589565454809, lat: 27.656425889592356 },
            { lng: -8.665124477564191, lat: 27.589479071558227 },
            { lng: -8.684399786809053, lat: 27.395744126896005 },
        ],
    ],
    [AfricaCountriesEnum.Eritrea]: [
        [
            { lng: 36.42951000000005, lat: 14.422110000000032 },
            { lng: 37.59377000000006, lat: 14.213099999999997 },
            { lng: 37.90607000000011, lat: 14.959430000000168 },
            { lng: 38.512950000000046, lat: 14.50547000000006 },
            { lng: 39.0994, lat: 14.740640000000042 },
            { lng: 39.34061000000008, lat: 14.531549999999982 },
            { lng: 40.02625000000012, lat: 14.519589999999994 },
            { lng: 40.896600000000035, lat: 14.118640000000141 },
            { lng: 41.15519999999998, lat: 13.773329999999987 },
            { lng: 41.59856000000002, lat: 13.452090000000112 },
            { lng: 42.00975, lat: 12.865819999999928 },
            { lng: 42.35156000000012, lat: 12.542230000000131 },
            { lng: 42.77964236834475, lat: 12.455415757695675 },
            { lng: 43.08122602720016, lat: 12.699638576707116 },
            { lng: 42.58957645037526, lat: 13.000421250861905 },
            { lng: 42.27683068214486, lat: 13.343992010954423 },
            { lng: 41.73495161313235, lat: 13.921036892141558 },
            { lng: 41.17927493669765, lat: 14.491079616753211 },
            { lng: 39.814293654140215, lat: 15.435647284400318 },
            { lng: 39.26611006038803, lat: 15.92272349696725 },
            { lng: 38.990622999840014, lat: 16.840626125551694 },
            { lng: 38.410089959473225, lat: 17.998307399970315 },
            { lng: 37.90400000000011, lat: 17.427540000000022 },
            { lng: 37.167470000000094, lat: 17.263140000000135 },
            { lng: 36.852530000000115, lat: 16.956549999999993 },
            { lng: 36.75389000000007, lat: 16.291860000000042 },
            { lng: 36.32321999999999, lat: 14.822490000000016 },
            { lng: 36.42951000000005, lat: 14.422110000000032 },
        ],
    ],
    [AfricaCountriesEnum.Morocco]: [
        [
            { lng: -2.169913702798624, lat: 35.16839630791668 },
            { lng: -2.604305792644084, lat: 35.179093329401155 },
            { lng: -3.640056525070065, lat: 35.399855048152006 },
            { lng: -4.591006232105144, lat: 35.330711981745594 },
            { lng: -5.193863491222032, lat: 35.75518219659085 },
            { lng: -5.92999426921989, lat: 35.75998810479399 },
            { lng: -6.2443420068514115, lat: 35.145865383437524 },
            { lng: -6.912544114601417, lat: 34.110476386037476 },
            { lng: -7.6541784326382185, lat: 33.69706492770251 },
            { lng: -8.657476365585012, lat: 33.240245266242425 },
            { lng: -9.300692918321886, lat: 32.564679266890664 },
            { lng: -9.434793260119363, lat: 32.038096421836485 },
            { lng: -9.814718390329176, lat: 31.17773550060906 },
            { lng: -9.564811163765683, lat: 29.93357371674989 },
            { lng: -10.399592251008642, lat: 29.09858592377782 },
            { lng: -10.900956997104402, lat: 28.83214223888092 },
            { lng: -11.688919236690765, lat: 28.148643907172527 },
            { lng: -12.618836635783111, lat: 28.03818553314869 },
            { lng: -13.121613369914769, lat: 27.65414767171984 },
            { lng: -8.817828334986672, lat: 27.656425889592356 },
            { lng: -8.665589565454809, lat: 27.656425889592356 },
            { lng: -8.674116176782974, lat: 28.84128896739658 },
            { lng: -7.059227667661958, lat: 29.5792284205246 },
            { lng: -6.060632290053774, lat: 29.731699734001694 },
            { lng: -5.242129278982787, lat: 30.00044302013559 },
            { lng: -4.859646165374471, lat: 30.501187649043846 },
            { lng: -3.6904410465547244, lat: 30.896951605751156 },
            { lng: -3.647497931320146, lat: 31.637294012980675 },
            { lng: -3.068980271812648, lat: 31.724497992473218 },
            { lng: -2.616604783529567, lat: 32.09434621838619 },
            { lng: -1.30789913573787, lat: 32.2628889023061 },
            { lng: -1.1245511539663084, lat: 32.65152151135713 },
            { lng: -1.388049282222596, lat: 32.86401500094138 },
            { lng: -1.7334545556614671, lat: 33.91971283623212 },
            { lng: -1.792985805661715, lat: 34.527918606091305 },
            { lng: -2.169913702798624, lat: 35.16839630791668 },
        ],
    ],
    [AfricaCountriesEnum.Egypt]: [
        [
            { lng: 36.86622999999997, lat: 22 },
            { lng: 36.690690000000004, lat: 22.20485 },
            { lng: 35.52598, lat: 23.10244 },
            { lng: 35.49372, lat: 23.752370000000003 },
            { lng: 35.69241, lat: 23.92671 },
            { lng: 34.79507, lat: 25.03375 },
            { lng: 34.473870000000005, lat: 25.598560000000003 },
            { lng: 34.10455, lat: 26.14227 },
            { lng: 33.34876, lat: 27.69989 },
            { lng: 32.73482, lat: 28.70523 },
            { lng: 32.32046, lat: 29.76043 },
            { lng: 32.423230000000004, lat: 29.851080000000003 },
            { lng: 33.13676, lat: 28.417650000000002 },
            { lng: 33.58811, lat: 27.97136 },
            { lng: 33.92136, lat: 27.6487 },
            { lng: 34.15451, lat: 27.8233 },
            { lng: 34.42655, lat: 28.343989999999998 },
            { lng: 34.64174, lat: 29.099420000000002 },
            { lng: 34.9226, lat: 29.50133 },
            { lng: 34.823243288783814, lat: 29.76108076171822 },
            { lng: 34.265440000000005, lat: 31.219359999999998 },
            { lng: 34.26543474464621, lat: 31.21935730952032 },
            { lng: 33.7734, lat: 30.967460000000003 },
            { lng: 32.99392, lat: 31.024070000000002 },
            { lng: 32.19247, lat: 31.26034 },
            { lng: 31.96041, lat: 30.933600000000002 },
            { lng: 31.687960000000004, lat: 31.4296 },
            { lng: 30.976930000000003, lat: 31.55586 },
            { lng: 30.09503, lat: 31.4734 },
            { lng: 29.683419999999998, lat: 31.186860000000003 },
            { lng: 28.913529999999998, lat: 30.87005 },
            { lng: 28.450480000000002, lat: 31.025769999999998 },
            { lng: 27.457620000000002, lat: 31.32126 },
            { lng: 26.49533, lat: 31.58568 },
            { lng: 25.16482, lat: 31.56915 },
            { lng: 24.802869999999984, lat: 31.089290000000005 },
            { lng: 24.957620000000002, lat: 30.6616 },
            { lng: 24.70007, lat: 30.044190000000004 },
            { lng: 25, lat: 29.23865452953346 },
            { lng: 25, lat: 25.682499996361 },
            { lng: 25, lat: 22 },
            { lng: 29.019999999999982, lat: 22 },
            { lng: 32.89999999999998, lat: 22 },
            { lng: 36.86622999999997, lat: 22 },
        ],
    ],
    [AfricaCountriesEnum.Libya]: [
        [
            { lng: 25, lat: 22 },
            { lng: 25, lat: 25.682499996361 },
            { lng: 25, lat: 29.23865452953346 },
            { lng: 24.70007, lat: 30.044190000000004 },
            { lng: 24.957620000000002, lat: 30.6616 },
            { lng: 24.802869999999984, lat: 31.089290000000005 },
            { lng: 25.16482, lat: 31.56915 },
            { lng: 24.921139999999923, lat: 31.89936 },
            { lng: 23.92750000000001, lat: 32.01667000000009 },
            { lng: 23.609130000000107, lat: 32.18725999999998 },
            { lng: 23.236800000000017, lat: 32.191490000000044 },
            { lng: 22.895760000000053, lat: 32.63857999999999 },
            { lng: 21.54298, lat: 32.843200000000024 },
            { lng: 20.854520000000093, lat: 32.70679999999999 },
            { lng: 20.13396999999992, lat: 32.238200000000006 },
            { lng: 19.82033000000007, lat: 31.751790000000142 },
            { lng: 20.053349999999966, lat: 30.985760000000028 },
            { lng: 19.574040000000082, lat: 30.52582000000001 },
            { lng: 19.08641, lat: 30.26639 },
            { lng: 18.02108999999996, lat: 30.76356999999996 },
            { lng: 16.611620000000016, lat: 31.18217999999996 },
            { lng: 15.713939999999923, lat: 31.376259999999945 },
            { lng: 15.245630000000006, lat: 32.26508000000007 },
            { lng: 13.918679999999995, lat: 32.71196000000009 },
            { lng: 13.083260000000053, lat: 32.878820000000076 },
            { lng: 12.663310000000024, lat: 32.79278000000005 },
            { lng: 11.488787469131012, lat: 33.13699575452324 },
            { lng: 11.432253452203696, lat: 32.368903103152874 },
            { lng: 10.944789666394456, lat: 32.081814683555365 },
            { lng: 10.636901482799487, lat: 31.761420803345757 },
            { lng: 9.950225050505082, lat: 31.376069647745258 },
            { lng: 10.056575148161699, lat: 30.961831366493527 },
            { lng: 9.970017124072854, lat: 30.53932485607524 },
            { lng: 9.482139926805274, lat: 30.307556057246188 },
            { lng: 9.805634392952356, lat: 29.424638373323376 },
            { lng: 9.859997999723447, lat: 28.959989732371014 },
            { lng: 9.683884718472768, lat: 28.1441738957792 },
            { lng: 9.756128370816782, lat: 27.688258571884205 },
            { lng: 9.629056023811074, lat: 27.14095347748092 },
            { lng: 9.716285841519664, lat: 26.512206325785655 },
            { lng: 9.319410841518163, lat: 26.094324856057455 },
            { lng: 9.910692579801776, lat: 25.365454616796796 },
            { lng: 9.94826134607797, lat: 24.936953640232517 },
            { lng: 10.303846876678362, lat: 24.379313259370917 },
            { lng: 10.771363559622927, lat: 24.56253205006175 },
            { lng: 11.560669386449005, lat: 24.097909247325518 },
            { lng: 11.999505649471613, lat: 23.47166840259645 },
            { lng: 13.581424594790462, lat: 23.04050608976928 },
            { lng: 14.143870883855243, lat: 22.491288967371133 },
            { lng: 14.851300000000037, lat: 22.862950000000126 },
            { lng: 15.860850000000084, lat: 23.409719999999993 },
            { lng: 19.849260000000072, lat: 21.49509000000006 },
            { lng: 23.83766000000014, lat: 19.580470000000105 },
            { lng: 23.850000000000136, lat: 20.000000000000057 },
            { lng: 25.000000000000114, lat: 20.003040000000055 },
            { lng: 25, lat: 22 },
        ],
    ],
    [AfricaCountriesEnum.Ethiopia]: [
        [
            { lng: 47.78942, lat: 8.003 },
            { lng: 46.94834000000009, lat: 7.99688000000009 },
            { lng: 43.678750000000036, lat: 9.18358000000012 },
            { lng: 43.29699000000011, lat: 9.540480000000173 },
            { lng: 42.92812000000009, lat: 10.021940000000143 },
            { lng: 42.55875999999995, lat: 10.57258000000013 },
            { lng: 42.77685184100096, lat: 10.92687856693442 },
            { lng: 42.55493000000013, lat: 11.105110000000195 },
            { lng: 42.31414000000012, lat: 11.034200000000055 },
            { lng: 41.755570000000205, lat: 11.050910000000101 },
            { lng: 41.73959000000019, lat: 11.355110000000138 },
            { lng: 41.66176000000013, lat: 11.631199999999978 },
            { lng: 42.000000000000114, lat: 12.100000000000136 },
            { lng: 42.35156000000012, lat: 12.542230000000131 },
            { lng: 42.00975, lat: 12.865819999999928 },
            { lng: 41.59856000000002, lat: 13.452090000000112 },
            { lng: 41.15519999999998, lat: 13.773329999999987 },
            { lng: 40.896600000000035, lat: 14.118640000000141 },
            { lng: 40.02625000000012, lat: 14.519589999999994 },
            { lng: 39.34061000000008, lat: 14.531549999999982 },
            { lng: 39.0994, lat: 14.740640000000042 },
            { lng: 38.512950000000046, lat: 14.50547000000006 },
            { lng: 37.90607000000011, lat: 14.959430000000168 },
            { lng: 37.59377000000006, lat: 14.213099999999997 },
            { lng: 36.42951000000005, lat: 14.422110000000032 },
            { lng: 36.27022000000005, lat: 13.563330000000121 },
            { lng: 35.86363, lat: 12.578280000000063 },
            { lng: 35.26049000000006, lat: 12.08286000000004 },
            { lng: 34.83163000000013, lat: 11.318960000000118 },
            { lng: 34.73115000000013, lat: 10.910170000000107 },
            { lng: 34.25745000000006, lat: 10.630089999999996 },
            { lng: 33.961620000000096, lat: 9.583580000000097 },
            { lng: 33.97498000000007, lat: 8.68455999999992 },
            { lng: 33.82550000000015, lat: 8.37916000000007 },
            { lng: 33.29480000000012, lat: 8.354580000000055 },
            { lng: 32.954180000000065, lat: 7.784970000000101 },
            { lng: 33.568290000000104, lat: 7.7133400000000165 },
            { lng: 34.07510000000002, lat: 7.2259500000000685 },
            { lng: 34.250320000000045, lat: 6.8260700000000725 },
            { lng: 34.70702, lat: 6.594220000000121 },
            { lng: 35.29800711823298, lat: 5.506 },
            { lng: 35.817447662353516, lat: 5.338232082790797 },
            { lng: 35.817447662353516, lat: 4.7769656634618896 },
            { lng: 36.159078632855646, lat: 4.447864127672769 },
            { lng: 36.85509323800812, lat: 4.447864127672769 },
            { lng: 38.120915, lat: 3.598605 },
            { lng: 38.43697, lat: 3.58851 },
            { lng: 38.67114, lat: 3.6160700000000006 },
            { lng: 38.89251, lat: 3.5007400000000004 },
            { lng: 39.55938425876585, lat: 3.42206 },
            { lng: 39.85494, lat: 3.83879 },
            { lng: 40.76848, lat: 4.257020000000001 },
            { lng: 41.1718, lat: 3.9190899999999997 },
            { lng: 41.85508309264397, lat: 3.918911920483727 },
            { lng: 42.128609999999995, lat: 4.23413 },
            { lng: 42.76967, lat: 4.25259 },
            { lng: 43.66086999999999, lat: 4.957550000000083 },
            { lng: 44.96360000000001, lat: 5.00162 },
            { lng: 47.78942, lat: 8.003 },
        ],
    ],
    [AfricaCountriesEnum.Djibouti]: [
        [
            { lng: 42.35156000000012, lat: 12.542230000000131 },
            { lng: 42.000000000000114, lat: 12.100000000000136 },
            { lng: 41.66176000000013, lat: 11.631199999999978 },
            { lng: 41.73959000000019, lat: 11.355110000000138 },
            { lng: 41.755570000000205, lat: 11.050910000000101 },
            { lng: 42.31414000000012, lat: 11.034200000000055 },
            { lng: 42.55493000000013, lat: 11.105110000000195 },
            { lng: 42.77685184100096, lat: 10.92687856693442 },
            { lng: 43.14530480324214, lat: 11.462039699748857 },
            { lng: 42.715873650896526, lat: 11.735640570518342 },
            { lng: 43.286381463398925, lat: 11.974928290245884 },
            { lng: 43.31785241066467, lat: 12.390148423711025 },
            { lng: 43.08122602720016, lat: 12.699638576707116 },
            { lng: 42.77964236834475, lat: 12.455415757695675 },
            { lng: 42.35156000000012, lat: 12.542230000000131 },
        ],
    ],
    [AfricaCountriesEnum.Uganda]: [
        [
            { lng: 33.90371119710453, lat: -0.9500000000000001 },
            { lng: 33.893568969666944, lat: 0.1098135378618963 },
            { lng: 34.18, lat: 0.515 },
            { lng: 34.6721, lat: 1.1769399999999999 },
            { lng: 35.03599, lat: 1.90584 },
            { lng: 34.59607, lat: 3.0537400000001185 },
            { lng: 34.47913, lat: 3.5556000000000836 },
            { lng: 34.005, lat: 4.249884947362048 },
            { lng: 33.3900000000001, lat: 3.7899999999999636 },
            { lng: 32.686420000000055, lat: 3.7923200000000747 },
            { lng: 31.881449999999973, lat: 3.558269999999993 },
            { lng: 31.24556000000007, lat: 3.7819000000000074 },
            { lng: 30.833852421715427, lat: 3.5091716042224625 },
            { lng: 30.83385989759381, lat: 3.509165961110341 },
            { lng: 30.77334679538004, lat: 2.339883327642127 },
            { lng: 31.174149204235817, lat: 2.204465236821264 },
            { lng: 30.85267011894806, lat: 1.8493964705438088 },
            { lng: 30.46850752129029, lat: 1.5838054467797065 },
            { lng: 30.086153598762706, lat: 1.0623127303062887 },
            { lng: 29.875778842902434, lat: 0.5973798689763612 },
            { lng: 29.819503208136638, lat: -0.2053101538133717 },
            { lng: 29.58783776217217, lat: -0.587405694179381 },
            { lng: 29.579466180140884, lat: -1.3413131648856265 },
            { lng: 29.821518588996014, lat: -1.4433224422297855 },
            { lng: 30.419104852019245, lat: -1.1346591121504161 },
            { lng: 30.769860000000108, lat: -1.0145499999999856 },
            { lng: 31.866170000000068, lat: -1.0273599999999306 },
            { lng: 33.90371119710453, lat: -0.9500000000000001 },
        ],
    ],
    [AfricaCountriesEnum.Rwanda]: [
        [
            { lng: 30.419104852019245, lat: -1.1346591121504161 },
            { lng: 29.821518588996014, lat: -1.4433224422297855 },
            { lng: 29.579466180140884, lat: -1.3413131648856265 },
            { lng: 29.291886834436614, lat: -1.6200558406679872 },
            { lng: 29.254834832483343, lat: -2.2151099585089113 },
            { lng: 29.117478875451553, lat: -2.2922111954883846 },
            { lng: 29.024926385216787, lat: -2.8392579077301576 },
            { lng: 29.632176141078588, lat: -2.917857761246097 },
            { lng: 29.93835900240794, lat: -2.348486830254238 },
            { lng: 30.469673645761223, lat: -2.41385475710134 },
            { lng: 30.469670000000008, lat: -2.4138299999999617 },
            { lng: 30.75830895358311, lat: -2.2872502579883687 },
            { lng: 30.816134881317712, lat: -1.6989140763453887 },
            { lng: 30.419104852019245, lat: -1.1346591121504161 },
        ],
    ],
    [AfricaCountriesEnum.SouthSudan]: [
        [
            { lng: 30.833852421715427, lat: 3.5091716042224625 },
            { lng: 31.24556000000007, lat: 3.7819000000000074 },
            { lng: 31.881449999999973, lat: 3.558269999999993 },
            { lng: 32.686420000000055, lat: 3.7923200000000747 },
            { lng: 33.3900000000001, lat: 3.7899999999999636 },
            { lng: 34.005, lat: 4.249884947362048 },
            { lng: 34.62019626785388, lat: 4.8471227420819885 },
            { lng: 35.29800711823298, lat: 5.506 },
            { lng: 34.70702, lat: 6.594220000000121 },
            { lng: 34.250320000000045, lat: 6.8260700000000725 },
            { lng: 34.07510000000002, lat: 7.2259500000000685 },
            { lng: 33.568290000000104, lat: 7.7133400000000165 },
            { lng: 32.954180000000065, lat: 7.784970000000101 },
            { lng: 33.29480000000012, lat: 8.354580000000055 },
            { lng: 33.82550000000015, lat: 8.37916000000007 },
            { lng: 33.97498000000007, lat: 8.68455999999992 },
            { lng: 33.963392794971185, lat: 9.464285229420625 },
            { lng: 33.82496348090751, lat: 9.484060845715362 },
            { lng: 33.84213085302815, lat: 9.981914637215993 },
            { lng: 33.72195924818311, lat: 10.325262079630193 },
            { lng: 33.206938084561784, lat: 10.720111638406593 },
            { lng: 33.086766479716744, lat: 11.441141267476496 },
            { lng: 33.206938084561784, lat: 12.179338268667095 },
            { lng: 32.743419037302544, lat: 12.248007757149992 },
            { lng: 32.67474954881965, lat: 12.02483191958072 },
            { lng: 32.073891524594785, lat: 11.973329803218519 },
            { lng: 32.31423473428475, lat: 11.68148447716652 },
            { lng: 32.400071594888345, lat: 11.080626452941488 },
            { lng: 31.850715687025513, lat: 10.531270545078826 },
            { lng: 31.35286189552488, lat: 9.810240916008695 },
            { lng: 30.837840731903384, lat: 9.70723668328452 },
            { lng: 29.996639497988554, lat: 10.290927335388687 },
            { lng: 29.61895731133285, lat: 10.084918869940225 },
            { lng: 29.515953078608618, lat: 9.793073543888056 },
            { lng: 29.000931914987177, lat: 9.60423245056029 },
            { lng: 28.966597170745786, lat: 9.398223985111656 },
            { lng: 27.970889587744352, lat: 9.398223985111656 },
            { lng: 27.833550610778786, lat: 9.60423245056029 },
            { lng: 27.112520981708883, lat: 9.638567194801624 },
            { lng: 26.752006167173818, lat: 9.466893473594496 },
            { lng: 26.477328213242515, lat: 9.552730334198088 },
            { lng: 25.962307049621018, lat: 10.136420986302426 },
            { lng: 25.790633328413946, lat: 10.411098940233728 },
            { lng: 25.069603699343986, lat: 10.273759963267992 },
            { lng: 24.794925745412684, lat: 9.810240916008695 },
            { lng: 24.53741516360202, lat: 8.91753756573172 },
            { lng: 24.19406772118765, lat: 8.728696472403897 },
            { lng: 23.886979580860668, lat: 8.619729712933065 },
            { lng: 24.567369012152085, lat: 8.229187933785468 },
            { lng: 25.11493248871679, lat: 7.825104071479174 },
            { lng: 25.124130893664727, lat: 7.500085150579437 },
            { lng: 25.79664798351118, lat: 6.979315904158071 },
            { lng: 26.213418409945117, lat: 6.546603298362072 },
            { lng: 26.465909458123235, lat: 5.9467174341018705 },
            { lng: 27.21340905122517, lat: 5.5509534773945575 },
            { lng: 27.37422610851749, lat: 5.233944403500061 },
            { lng: 27.97997724784281, lat: 4.408413397637375 },
            { lng: 28.428993768026913, lat: 4.287154649264494 },
            { lng: 28.696677687298802, lat: 4.455077215996937 },
            { lng: 29.1590784034465, lat: 4.389267279473231 },
            { lng: 29.71599531425602, lat: 4.600804755060153 },
            { lng: 29.953500197069474, lat: 4.173699042167684 },
            { lng: 30.833852421715427, lat: 3.5091716042224625 },
        ],
    ],
};

export const AfricaCountriesAreas: Record<AfricaCountriesEnum, Rect> = {
    [AfricaCountriesEnum.Morocco]: { left: -9.2, top: 33.5, width: 4, height: -4 },
    [AfricaCountriesEnum.Algeria]: { left: -3.4, top: 34, width: 13, height: -13 },
    [AfricaCountriesEnum.Tunisia]: { left: 7.7, top: 36.4, width: 3.6, height: -3.6 },
    [AfricaCountriesEnum.Libya]: { left: 12.5, top: 32, width: 10, height: -10 },
    [AfricaCountriesEnum.Egypt]: { left: 24.8, top: 31.7, width: 9.6, height: -9.6 },
    [AfricaCountriesEnum.WesternSahara]: { left: -15, top: 26.2, width: 3.2, height: -3.2 },
    [AfricaCountriesEnum.Mauritania]: { left: -13.5, top: 23.5, width: 8, height: -8 },
    [AfricaCountriesEnum.Mali]: { left: -6, top: 22, width: 7.5, height: -7.5 },
    [AfricaCountriesEnum.Niger]: { left: 6, top: 21, width: 8, height: -8 },
    [AfricaCountriesEnum.Chad]: { left: 14.5, top: 19.5, width: 8, height: -8 },
    [AfricaCountriesEnum.Sudan]: { left: 24, top: 22, width: 12, height: -12 },
    [AfricaCountriesEnum.Eritrea]: { left: 36.5, top: 17.3, width: 2.6, height: -2.6 },
    [AfricaCountriesEnum.Senegal]: { left: -16.5, top: 16.5, width: 3, height: -3 },
    [AfricaCountriesEnum.Gambia]: { left: -16.4, top: 13.6, width: 0.5, height: -0.5 },
    [AfricaCountriesEnum.GuineaBissau]: { left: -16, top: 12.7, width: 1.4, height: -1.4 },
    [AfricaCountriesEnum.Guinea]: { left: -11.2, top: 12.1, width: 2.8, height: -2.8 },
    [AfricaCountriesEnum.SierraLeone]: { left: -12.85, top: 9.7, width: 2.2, height: -2.2 },
    [AfricaCountriesEnum.Liberia]: { left: -10.7, top: 7.7, width: 2.4, height: -2.4 },
    [AfricaCountriesEnum.CoteDIvoire]: { left: -8, top: 10, width: 5, height: -5 },
    [AfricaCountriesEnum.BurkinaFaso]: { left: -2.6, top: 14.3, width: 3.3, height: -3.3 },
    [AfricaCountriesEnum.Ghana]: { left: -3.1, top: 10, width: 3.8, height: -3.8 },
    [AfricaCountriesEnum.Togo]: { left: 0.3, top: 9.7, width: 1.2, height: -1.2 },
    [AfricaCountriesEnum.Benin]: { left: 1.3, top: 11.8, width: 2.3, height: -2.3 },
    [AfricaCountriesEnum.Nigeria]: { left: 3.7, top: 13.4, width: 6.9, height: -6.9 },
    [AfricaCountriesEnum.Cameroon]: { left: 9.7, top: 7.2, width: 5.1, height: -5.1 },
    [AfricaCountriesEnum.CentAfrRep]: { left: 18.7, top: 9.5, width: 5.1, height: -5.1 },
    [AfricaCountriesEnum.SouthSudan]: { left: 27.5, top: 10.2, width: 6.2, height: -6.2 },
    [AfricaCountriesEnum.Ethiopia]: { left: 35.6, top: 11.7, width: 7.3, height: -7.3 },
    [AfricaCountriesEnum.Djibouti]: { left: 41.9, top: 12.4, width: 1.2, height: -1.2 },
    [AfricaCountriesEnum.Somalia]: { left: 46.7, top: 11.4, width: 3.8, height: -3.8 },
    [AfricaCountriesEnum.EqGuinea]: { left: 9.8, top: 2.3, width: 1.2, height: -1.2 },
    [AfricaCountriesEnum.Gabon]: { left: 9.9, top: 1.4, width: 3.9, height: -3.9 },
    [AfricaCountriesEnum.RepOfCongo]: { left: 14, top: 2.3, width: 3.7, height: -3.7 },
    [AfricaCountriesEnum.DemocraticRepOfCongo]: { left: 17.4, top: 5, width: 13.2, height: -13.2 },
    [AfricaCountriesEnum.Uganda]: { left: 30.4, top: 3.6, width: 4, height: -4 },
    [AfricaCountriesEnum.Rwanda]: { left: 29.4, top: -1.3, width: 1.2, height: -1.2 },
    [AfricaCountriesEnum.Burundi]: { left: 29.2, top: -2.9, width: 1.2, height: -1.2 },
    [AfricaCountriesEnum.Kenya]: { left: 34.7, top: 4.2, width: 6.4, height: -6.4 },
    [AfricaCountriesEnum.Tanzania]: { left: 30.5, top: -2.2, width: 7.2, height: -7.2 },
    [AfricaCountriesEnum.Angola]: { left: 12.8, top: -7.7, width: 9.6, height: -9.6 },
    [AfricaCountriesEnum.Zambia]: { left: 23, top: -12.1, width: 5.4, height: -5.4 },
    [AfricaCountriesEnum.Malawi]: { left: 32.8, top: -12.4, width: 1.8, height: -1.8 },
    [AfricaCountriesEnum.Mozambique]: { left: 35.3, top: -11.3, width: 5.4, height: -5.4 },
    [AfricaCountriesEnum.Namibia]: { left: 14.1, top: -19.3, width: 6.2, height: -6.2 },
    [AfricaCountriesEnum.Botswana]: { left: 19.9, top: -18.2, width: 7.2, height: -7.2 },
    [AfricaCountriesEnum.Zimbabwe]: { left: 27.6, top: -16.4, width: 5.2, height: -5.2 },
    [AfricaCountriesEnum.SouthAfrica]: { left: 19.8, top: -26.7, width: 7.7, height: -7.7 },
    [AfricaCountriesEnum.Lesotho]: { left: 27.6, top: -28.9, width: 1.3, height: -1.3 },
    [AfricaCountriesEnum.Eswatini]: { left: 30.8, top: -25.9, width: 1.2, height: -1.2 },
};
